"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9826],{

/***/ 65186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(65618);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(95196);
;// CONCATENATED MODULE: ./src/components/atoms/button/variants/outline.tsx
var outline = {
    _hover: {
        bgColor: 'primary.500',
        borderColor: 'primary.500',
        color: 'white'
    },
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'primary.500',
    bgColor: 'transparent',
    color: 'primary.500'
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/solid.tsx
var solid = {
    _hover: {
        bgColor: 'primary.300'
    },
    bgColor: 'primary.500',
    color: 'white'
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/outlineNewPurple.tsx
var outlineNewPurple = {
    _hover: {
        bgColor: 'companyPurple.500',
        borderColor: 'companyPurple.500',
        color: 'white'
    },
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'companyPurple.500',
    bgColor: 'transparent',
    color: 'companyPurple.500'
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/solidNewPurple.tsx
var solidNewPurple = {
    _hover: {
        bgColor: 'companyPurple.500',
        opacity: 0.7
    },
    bgColor: 'companyPurple.500',
    color: 'white'
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/disabledSolid.tsx
var disabledSolid = {
    bgColor: '#E6E6E6',
    color: 'neutralBlack.500',
    fontWeight: '700',
    _disabled: {
        opacity: 1,
        cursor: 'not-allowed'
    }
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/outlineRed.tsx
var outlineRed = {
    _hover: {
        bgColor: 'red',
        borderColor: 'red',
        color: 'white'
    },
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'red',
    bgColor: 'transparent',
    color: 'red'
};

;// CONCATENATED MODULE: ./src/components/atoms/button/variants/index.tsx






var variants = {
    outline: outline,
    solid: solid,
    outlineNewPurple: outlineNewPurple,
    solidNewPurple: solidNewPurple,
    disabledSolid: disabledSolid,
    outlineRed: outlineRed
};

;// CONCATENATED MODULE: ./src/components/atoms/button/index.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var _variant = _param.variant, variant = _variant === void 0 ? 'solid' : _variant, rightIconProps = _param.rightIconProps, leftIconProps = _param.leftIconProps, rightIcon = _param.rightIcon, leftIcon = _param.leftIcon, children = _param.children, _p = _param.p, p = _p === void 0 ? '8px 16px' : _p, props = _objectWithoutProperties(_param, [
        "variant",
        "rightIconProps",
        "leftIconProps",
        "rightIcon",
        "leftIcon",
        "children",
        "p"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, _objectSpread({
        borderRadius: 4,
        fontFamily: "heading",
        fontSize: "12px",
        fontWeight: "700",
        letterSpacing: "1.5px",
        ref: ref,
        p: p,
        textTransform: "uppercase",
        leftIcon: leftIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, _objectSpread({
            as: leftIcon,
            w: 5,
            h: 5
        }, leftIconProps)),
        rightIcon: rightIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, _objectSpread({
            as: rightIcon,
            w: 5,
            h: 5
        }, rightIconProps)),
        isDisabled: variant === 'disabledSolid',
        "data-testid": "button"
    }, variants[variant], props, {
        children: children
    }));
});
Button.displayName = 'Button';
/* harmony default export */ var atoms_button = (Button);


/***/ }),

/***/ 55098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95196);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50167);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HeaderLinkLabel = function(_param) {
    var _renderChevron = _param.renderChevron, renderChevron = _renderChevron === void 0 ? false : _renderChevron, _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _borderBottomWidth = _param.borderBottomWidth, borderBottomWidth = _borderBottomWidth === void 0 ? 2 : _borderBottomWidth, children = _param.children, props = _objectWithoutProperties(_param, [
        "renderChevron",
        "isSelected",
        "borderBottomWidth",
        "children"
    ]);
    var selectedStyle = {
        color: 'primary.500',
        borderBottomColor: {
            base: 'transparent',
            md: 'primary.500'
        },
        bgColor: {
            base: 'primary.150',
            md: 'transparent'
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, _objectSpread({
        _hover: selectedStyle,
        borderBottomStyle: "solid",
        borderBottomWidth: borderBottomWidth,
        borderBottomColor: "white.100",
        color: "black.300",
        cursor: "pointer",
        fontFamily: "body",
        fontSize: 10,
        fontWeight: "700",
        letterSpacing: 1.2,
        ml: {
            base: 0,
            md: 8
        },
        px: {
            base: 6,
            md: 0
        },
        py: {
            base: 3,
            md: 1.5
        },
        sx: isSelected ? selectedStyle : {},
        textTransform: "uppercase",
        transition: "0.2s"
    }, props, {
        children: [
            children,
            renderChevron && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                as: react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiChevronDown */ .bTu,
                h: 3,
                w: 3,
                ml: 3
            })
        ]
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderLinkLabel);


/***/ }),

/***/ 54209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ geekLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(80241);
;// CONCATENATED MODULE: ./public/geek-logo.svg
/* harmony default export */ var geek_logo = ({"src":"/_next/static/media/geek-logo.5e162598.svg","height":34,"width":231});
;// CONCATENATED MODULE: ./public/geek-logo-white.svg
/* harmony default export */ var geek_logo_white = ({"src":"/_next/static/media/geek-logo-white.d4f2e855.svg","height":652,"width":1326});
;// CONCATENATED MODULE: ./public/logo_white_horizontal.svg
/* harmony default export */ var logo_white_horizontal = ({"src":"/_next/static/media/logo_white_horizontal.3835655b.svg","height":22,"width":141});
;// CONCATENATED MODULE: ./src/components/atoms/images/geekLogo/index.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var logo = {
    standard: {
        src: geek_logo,
        width: '150px',
        height: '30px'
    },
    white: {
        src: geek_logo_white,
        width: '165px',
        height: '80px'
    },
    horizontal: {
        src: logo_white_horizontal,
        width: '150px',
        height: '30px'
    }
};
var GeekLogo = function(_param) /*#__PURE__*/ {
    var _type = _param.type, type = _type === void 0 ? 'standard' : _type, props = _objectWithoutProperties(_param, [
        "type"
    ]);
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], _objectSpread({
            "data-testid": "header-logo",
            alt: "GeekHunter Logo"
        }, logo[type], props))
    });
};
/* harmony default export */ var geekLogo = (GeekLogo);


/***/ }),

/***/ 92015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ThemeProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/chakra-ui-react.esm.js + 2 modules
var chakra_ui_react_esm = __webpack_require__(78194);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(16166);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/theme-tools/dist/chakra-ui-theme-tools.esm.js + 6 modules
var chakra_ui_theme_tools_esm = __webpack_require__(36111);
;// CONCATENATED MODULE: ./src/lib/settings/theme/colors/shared.ts
var sharedColorsScheme = {
    purple: {
        100: '#DBCEF5',
        200: '#F7E7FF',
        300: '#DFA7FE'
    },
    blue: {
        100: '#1E90FF',
        200: '#41A9B9',
        800: '#1C202B',
        900: '#090917'
    },
    black: {
        300: '#000000',
        400: '#C7CBCF',
        500: '#ACACAD',
        600: '#3A3A3A',
        650: '#6B757D',
        700: '#11273a',
        750: '#202024',
        800: '#18171B',
        900: '#040C10'
    },
    neutralBlack: {
        100: '#F5F5F7',
        200: '#E1E2EB',
        300: '#DABBCC',
        400: '#9B9DBZ',
        500: '#77798C',
        600: '#545669',
        700: '#363847',
        800: '#1C202B',
        900: '#090917'
    },
    neutralWhite: {
        100: '#FCFCFC'
    },
    grey: {
        100: '#CBD5E0',
        200: '#444A51',
        300: '#E5F0FD',
        400: '#C1C6CC',
        500: '#BABBCC',
        600: '#D2D5D8',
        800: '#737380',
        900: '#6B757D'
    },
    white: {
        100: '#FFFFFF',
        200: '#F2F4F6'
    },
    green: {
        100: '#EBF7F4',
        200: '#CEF0EA',
        300: '#9EDED8',
        400: '#6FCCC3',
        500: '#47BFAF',
        600: '#00A393',
        700: '#00857C',
        800: '#006664',
        900: '#004B4F',
        950: '#3BB49D'
    },
    red: {
        100: '#E62F5C'
    },
    companyPurple: {
        100: '#be70ea',
        200: '#b459e6',
        300: '#a941e3',
        400: '#9e29df',
        500: '#9412DC',
        600: '#8510c6',
        700: '#760eb0',
        800: '#670c9a',
        900: '#580a84'
    }
};

;// CONCATENATED MODULE: ./src/lib/settings/theme/index.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var sizes = {
    container: {
        xxl: '1600px'
    }
};
var space = {
    18: '4.5rem',
    128: '32rem'
};
var fonts = {
    heading: "'Poppins', sans-serif",
    body: "'Open Sans', sans-serif"
};
var breakpoints = (0,chakra_ui_theme_tools_esm/* createBreakpoints */._n)({
    sm: '40em',
    md: '52em',
    lg: '64em',
    xl: '80em'
});
var config = {
    initialColorMode: 'light'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var buildTheme = function(colors) {
    return (0,chakra_ui_react_esm/* extendTheme */.B1C)({
        scrollBehavior: 'smooth',
        colors: _objectSpread({}, sharedColorsScheme, colors),
        fonts: fonts,
        space: space,
        breakpoints: breakpoints,
        config: config,
        sizes: sizes,
        components: {
            Button: {
                sizes: {
                    xl: {
                        py: 8,
                        px: 8,
                        w: 400,
                        h: '50px'
                    },
                    xxl: {
                        py: 8,
                        px: 8,
                        w: 400,
                        h: '64px'
                    }
                }
            }
        }
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/themeProvider/index.tsx




var ThemeProvider = function(param) {
    var children = param.children, colors = param.colors;
    var theme = (0,react.useMemo)(function() {
        return buildTheme(colors);
    }, [
        colors
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_react_esm/* ChakraProvider */.xjn, {
        resetCSS: true,
        theme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_color_mode_esm/* ColorModeScript */.ZQ, {
                initialColorMode: theme.config.initialColorMode
            }),
            children
        ]
    }));
};


/***/ }),

/***/ 12062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JS": function() { return /* binding */ SHOW_COMPANY_NAME_JOB; },
/* harmony export */   "$A": function() { return /* binding */ USER_TYPE; },
/* harmony export */   "Ky": function() { return /* binding */ NEXT_LOCALE; }
/* harmony export */ });
/* unused harmony exports SHOW_NEW_FEATURE_BOOLEAN_SEARCH, SHOW_GUPY_INTEGRATION_ACCESS_MODAL_COMPANY_SEARCH_CANDIDATES_PAGE */
var SHOW_NEW_FEATURE_BOOLEAN_SEARCH = 'show_new_feature_boolean_search';
var SHOW_COMPANY_NAME_JOB = 'show_company_name_job';
var USER_TYPE = 'user_type';
var NEXT_LOCALE = 'NEXT_LOCALE';
var SHOW_GUPY_INTEGRATION_ACCESS_MODAL_COMPANY_SEARCH_CANDIDATES_PAGE = 'show_gupy_integration_access_modal_company_search_candidates_page';


/***/ }),

/***/ 8366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ TRANSLATE_NAMESPACES; }
/* harmony export */ });
/** NAME SPACES */ var namespaces = {
    createProfile: 'criar_perfil_gratis',
    statusCandidateOffLimits: 'status_candidate_off_limits',
    techRecuiterSignin: 'tech_recruiter_signin',
    companyCandidates: 'companies_candidatos',
    companyAcceptTermsOfUse: 'companies_accept_terms_of_use',
    companyPausedPackage: 'companies_paused_package',
    companySecuritySettings: 'companies_security_settings',
    global: 'global',
    companiesSignupFlow: 'companies_signup_flow',
    menuHeader: 'menu_header',
    plataformFooter: 'plataform_footer',
    candidateDashboard: 'candidate_dashboard',
    companySubscription: 'companies_subscription',
    companyHubSalaries: 'companies_hub_salaries',
    companyHub: 'companies_hub'
};
// TRANSLATE_NAMESPACES is now an immutable object, so no import will be able to change it
var TRANSLATE_NAMESPACES = Object.freeze(namespaces);


/***/ }),

/***/ 16402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uhR": function() { return /* binding */ ActivityLogEventTypeEnum; },
/* harmony export */   "lf1": function() { return /* binding */ AmplitudeHitOptionsEnum; },
/* harmony export */   "Foh": function() { return /* binding */ AmplitudeUserTypeEnum; },
/* harmony export */   "Lir": function() { return /* binding */ AssessmentLevelEnum; },
/* harmony export */   "twC": function() { return /* binding */ BidOriginEnum; },
/* harmony export */   "wyH": function() { return /* binding */ BidStatusEnum; },
/* harmony export */   "s6Q": function() { return /* binding */ CandidateInterestJobInterestTypeEnum; },
/* harmony export */   "J2p": function() { return /* binding */ CareerSlugEnum; },
/* harmony export */   "Trl": function() { return /* binding */ CompanyDemoEnum; },
/* harmony export */   "L0m": function() { return /* binding */ CompanyLocationEnum; },
/* harmony export */   "d15": function() { return /* binding */ CompanyPackageStatusEnum; },
/* harmony export */   "yHO": function() { return /* binding */ CompanyPlanUpgradeTriggerEnum; },
/* harmony export */   "rXU": function() { return /* binding */ CompanyStatusEnum; },
/* harmony export */   "f7x": function() { return /* binding */ CompanyUserAccessHubEnum; },
/* harmony export */   "Pq3": function() { return /* binding */ CompanyUserRoleEnum; },
/* harmony export */   "vck": function() { return /* binding */ EducationLevelEnum; },
/* harmony export */   "xCl": function() { return /* binding */ ExperienceLevelEnum; },
/* harmony export */   "VXP": function() { return /* binding */ GenderEnum; },
/* harmony export */   "Zpt": function() { return /* binding */ HiringOptionEnum; },
/* harmony export */   "a_7": function() { return /* binding */ JobTypeEnum; },
/* harmony export */   "Zwd": function() { return /* binding */ NoteTypeEnum; },
/* harmony export */   "lzH": function() { return /* binding */ OrderEnum; },
/* harmony export */   "XL7": function() { return /* binding */ PaymentMethod; },
/* harmony export */   "TBW": function() { return /* binding */ PeriodEnum; },
/* harmony export */   "Hx1": function() { return /* binding */ RegistrationFlowEnum; },
/* harmony export */   "XmB": function() { return /* binding */ ScheduleTypeEnum; },
/* harmony export */   "DKh": function() { return /* binding */ SearchPoolFilterEnum; },
/* harmony export */   "sL0": function() { return /* binding */ SearchStatusEnum; },
/* harmony export */   "JUw": function() { return /* binding */ SearchStatusFilterEnum; },
/* harmony export */   "lJm": function() { return /* binding */ SeniorityEnum; },
/* harmony export */   "ZYT": function() { return /* binding */ SituationEnum; },
/* harmony export */   "SqY": function() { return /* binding */ SpecialNecessityEnum; },
/* harmony export */   "tnS": function() { return /* binding */ SupportedProcessor; },
/* harmony export */   "xNd": function() { return /* binding */ TierEnum; },
/* harmony export */   "IBT": function() { return /* binding */ WorkModeEnum; },
/* harmony export */   "zmn": function() { return /* binding */ WorkRemoteEnum; },
/* harmony export */   "jZD": function() { return /* binding */ useRegisterAmplitudeHitMutation; },
/* harmony export */   "A2P": function() { return /* binding */ useRegisterAmplitudeHitAuthenticatedMutation; },
/* harmony export */   "lNF": function() { return /* binding */ useCandidateRegisterStepAboutMutation; },
/* harmony export */   "LHT": function() { return /* binding */ useCandidateRegisterStepCareerMutation; },
/* harmony export */   "GUr": function() { return /* binding */ useCandidateRegisterStepExperiencesMutation; },
/* harmony export */   "j7l": function() { return /* binding */ useCandidateRegisterStepImageMutation; },
/* harmony export */   "zu8": function() { return /* binding */ useCandidateRegisterStepLinkedinMutation; },
/* harmony export */   "$Z6": function() { return /* binding */ useCandidateRegisterStepProfileMutation; },
/* harmony export */   "dSR": function() { return /* binding */ useCandidateRegisterStepSkillsMutation; },
/* harmony export */   "L_e": function() { return /* binding */ useUpdateCandidateMutation; },
/* harmony export */   "rx6": function() { return /* binding */ useCreateCurrentCandidateActivityLogMutation; },
/* harmony export */   "yd_": function() { return /* binding */ useCreateCurrentCandidateAvailableFeedbackMutation; },
/* harmony export */   "DP5": function() { return /* binding */ useRegisterCandidateFirstStepMutation; },
/* harmony export */   "TTz": function() { return /* binding */ useSetCurrentCandidateDashboardFirstAccessMutation; },
/* harmony export */   "CEU": function() { return /* binding */ useSetCurrentCandidateStatusMutation; },
/* harmony export */   "CeV": function() { return /* binding */ useSetCurrentCandidateWhatsappNotificationMutation; },
/* harmony export */   "WiX": function() { return /* binding */ useCreateProspectMutation; },
/* harmony export */   "aQW": function() { return /* binding */ usePurchasePlanMutation; },
/* harmony export */   "uT5": function() { return /* binding */ useAcceptCompanyUserTermsOfServiceMutation; },
/* harmony export */   "fc8": function() { return /* binding */ useCompanyCancelSubscriptionMutation; },
/* harmony export */   "EY0": function() { return /* binding */ useCompanyRequestUpgradeMutation; },
/* harmony export */   "LXp": function() { return /* binding */ useCreateBidMutation; },
/* harmony export */   "PBW": function() { return /* binding */ useCreateNoteMutation; },
/* harmony export */   "hZb": function() { return /* binding */ useCreateScreeningCandidateMutation; },
/* harmony export */   "hQW": function() { return /* binding */ useDisableTwoFactorAuthenticationMutation; },
/* harmony export */   "xRA": function() { return /* binding */ useEnableTwoFactorAuthenticationMutation; },
/* harmony export */   "p1j": function() { return /* binding */ useGenerateTwoFactorAuthenticationSecretMutation; },
/* harmony export */   "V9d": function() { return /* binding */ useRejectCandidateInterestJobMutation; },
/* harmony export */   "wog": function() { return /* binding */ useScheduleDemonstrationMutation; },
/* harmony export */   "eNt": function() { return /* binding */ useSendUserEmailConfirmationInstructionsMutation; },
/* harmony export */   "cFf": function() { return /* binding */ useToggleFavoriteCandidateMutation; },
/* harmony export */   "B9Q": function() { return /* binding */ useToggleHiddenCandidateMutation; },
/* harmony export */   "QEY": function() { return /* binding */ useUpdateCompanyCandidateSearchResultClickedMutation; },
/* harmony export */   "wuH": function() { return /* binding */ useUpdateNoteMutation; },
/* harmony export */   "FMs": function() { return /* binding */ useUpdatePartnerIntegrationMutation; },
/* harmony export */   "EO_": function() { return /* binding */ useCreateCompanyUserMutation; },
/* harmony export */   "L$E": function() { return /* binding */ useSwitchCompanyUserLanguageMutation; },
/* harmony export */   "OZp": function() { return /* binding */ useToggleActiveMutation; },
/* harmony export */   "F4M": function() { return /* binding */ useUpdateCompanyUserMutation; },
/* harmony export */   "bro": function() { return /* binding */ useCreateCurrentCandidateInterestJobMutation; },
/* harmony export */   "g0c": function() { return /* binding */ useCheckCandidateIsRegisteredQuery; },
/* harmony export */   "vqJ": function() { return /* binding */ useGetCandidateProfileDataQuery; },
/* harmony export */   "wuo": function() { return /* binding */ useGetCurrentCandidateHiringQuery; },
/* harmony export */   "PnY": function() { return /* binding */ useGetCurrentCandidateImageQuery; },
/* harmony export */   "q3r": function() { return /* binding */ useGetCurrentCandidateInterestJobsByJobIdsQuery; },
/* harmony export */   "Nvr": function() { return /* binding */ useGetCurrentCandidatePendingBidsQuery; },
/* harmony export */   "Pqs": function() { return /* binding */ useGetCurrentCandidatePendingInterviewsQuery; },
/* harmony export */   "vCO": function() { return /* binding */ useGetCurrentCandidateUnreadMessagesQuery; },
/* harmony export */   "RGy": function() { return /* binding */ useGetCurrentCandidateWhatsAppNotificationStatusQuery; },
/* harmony export */   "HUP": function() { return /* binding */ useGetFocusSuggestionsQuery; },
/* harmony export */   "yyZ": function() { return /* binding */ useGetRegisterSuggestionsQuery; },
/* harmony export */   "jVY": function() { return /* binding */ useImportLinkedinProfileQuery; },
/* harmony export */   "ckZ": function() { return /* binding */ useListCareersQuery; },
/* harmony export */   "gYs": function() { return /* binding */ useCheckPasswordQuery; },
/* harmony export */   "j2K": function() { return /* binding */ useCheckTwoFactorAuthenticationCodeQuery; },
/* harmony export */   "V$O": function() { return /* binding */ useGetAccountManagerInfoForHeaderQuery; },
/* harmony export */   "wss": function() { return /* binding */ useGetActiveFocusesQuery; },
/* harmony export */   "$E2": function() { return /* binding */ useGetCandidateFilterOptionsByIdQuery; },
/* harmony export */   "e4_": function() { return /* binding */ useGetCandidateFilterSelectOptionsQuery; },
/* harmony export */   "Y9B": function() { return /* binding */ useGetCompanyAccountInfoForHeaderQuery; },
/* harmony export */   "e_x": function() { return /* binding */ useGetCurrentActiveJobsSearchCandidatesQuery; },
/* harmony export */   "UGv": function() { return /* binding */ useGetCurrentCompanyUserQuery; },
/* harmony export */   "Gzl": function() { return /* binding */ useGetCurrentCompanyUserBasicInfoQuery; },
/* harmony export */   "LJU": function() { return /* binding */ useGetCurrentCompanyUserIsConfirmedQuery; },
/* harmony export */   "fR7": function() { return /* binding */ useGetGupyIntegrationQuery; },
/* harmony export */   "AlJ": function() { return /* binding */ useCountHubPositionsByCompanyLazyQuery; },
/* harmony export */   "Gp1": function() { return /* binding */ useGetHubPositionsByCompanyQuery; },
/* harmony export */   "yp_": function() { return /* binding */ useGetHubPositionsByCompanyLazyQuery; },
/* harmony export */   "k2b": function() { return /* binding */ useSearchCandidatesLazyQuery; },
/* harmony export */   "rgK": function() { return /* binding */ useSearchCandidatesTotalsLazyQuery; },
/* harmony export */   "UYh": function() { return /* binding */ useFindActiveJobsByCompanyUserWhoIsResponsibleQuery; },
/* harmony export */   "bm2": function() { return /* binding */ useFindPendingBidsByCompanyUserWhoIsResponsibleQuery; },
/* harmony export */   "FGB": function() { return /* binding */ useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery; },
/* harmony export */   "Z3N": function() { return /* binding */ useGetAllCompanyUsersFromCurrentCompanyQuery; },
/* harmony export */   "WMl": function() { return /* binding */ useGetCompanyUserByIdQuery; },
/* harmony export */   "K95": function() { return /* binding */ useFindMaxMinJobsSalaryQuery; },
/* harmony export */   "iNG": function() { return /* binding */ useFindShowcaseJobsLazyQuery; },
/* harmony export */   "uJP": function() { return /* binding */ useGetScreeningByJobIdQuery; },
/* harmony export */   "dc3": function() { return /* binding */ useSearchCitiesQuery; },
/* harmony export */   "FHg": function() { return /* binding */ useSearchCitiesLazyQuery; },
/* harmony export */   "dgQ": function() { return /* binding */ useSearchCompanyAliasQuery; },
/* harmony export */   "hcL": function() { return /* binding */ useSearchTechsQuery; },
/* harmony export */   "q5Q": function() { return /* binding */ useSearchTechsLazyQuery; }
/* harmony export */ });
/* unused harmony exports ActorModelsEnum, AvailableFeedbackEnum, CompanyCountryEnum, CompanyPackageEnum, CompanySegmentationEnum, CompanyUserActivityLogEventTypeEnum, CompanyUserLanguageEnum, EventTypeEnum, FeatureFlagsEnum, HiringEnumTypes, TeamMemberRoleTypeEnum, TechnologySubtypeEnum, RegisterAmplitudeHitDocument, RegisterAmplitudeHitAuthenticatedDocument, CandidateRegisterStepAboutDocument, CandidateRegisterStepCareerDocument, CandidateRegisterStepExperiencesDocument, CandidateRegisterStepImageDocument, CandidateRegisterStepLinkedinDocument, CandidateRegisterStepProfileDocument, CandidateRegisterStepSkillsDocument, UpdateCandidateDocument, CreateCurrentCandidateActivityLogDocument, CreateCurrentCandidateAvailableFeedbackDocument, RegisterCandidateFirstStepDocument, SetCurrentCandidateDashboardFirstAccessDocument, SetCurrentCandidateStatusDocument, SetCurrentCandidateWhatsappNotificationDocument, CreateProspectDocument, PurchasePlanDocument, AcceptCompanyUserTermsOfServiceDocument, CompanyCancelSubscriptionDocument, CompanyRequestUpgradeDocument, CreateBidDocument, CreateNoteDocument, CreateScreeningCandidateDocument, DisableTwoFactorAuthenticationDocument, EnableTwoFactorAuthenticationDocument, GenerateTwoFactorAuthenticationSecretDocument, RejectCandidateInterestJobDocument, ScheduleDemonstrationDocument, SendUserEmailConfirmationInstructionsDocument, ToggleFavoriteCandidateDocument, ToggleHiddenCandidateDocument, UpdateCompanyCandidateSearchResultClickedDocument, UpdateNoteDocument, UpdatePartnerIntegrationDocument, CreateCompanyUserDocument, CreateCompanyUserActivityLogDocument, useCreateCompanyUserActivityLogMutation, SwitchCompanyUserLanguageDocument, ToggleActiveDocument, UpdateCompanyUserDocument, CreateCurrentCandidateInterestJobDocument, CheckCandidateIsRegisteredDocument, useCheckCandidateIsRegisteredLazyQuery, GetCandidateProfileDataDocument, useGetCandidateProfileDataLazyQuery, GetCurrentCandidateAvailableDocument, useGetCurrentCandidateAvailableQuery, useGetCurrentCandidateAvailableLazyQuery, GetCurrentCandidateBasicInfoDocument, useGetCurrentCandidateBasicInfoQuery, useGetCurrentCandidateBasicInfoLazyQuery, GetCurrentCandidateHiringDocument, useGetCurrentCandidateHiringLazyQuery, GetCurrentCandidateImageDocument, useGetCurrentCandidateImageLazyQuery, GetCurrentCandidateInterestJobsByJobIdsDocument, useGetCurrentCandidateInterestJobsByJobIdsLazyQuery, GetCurrentCandidateMainInfoDocument, useGetCurrentCandidateMainInfoQuery, useGetCurrentCandidateMainInfoLazyQuery, GetCurrentCandidateMd5EmailDocument, useGetCurrentCandidateMd5EmailQuery, useGetCurrentCandidateMd5EmailLazyQuery, GetCurrentCandidatePendingBidsDocument, useGetCurrentCandidatePendingBidsLazyQuery, GetCurrentCandidatePendingInterviewsDocument, useGetCurrentCandidatePendingInterviewsLazyQuery, GetCurrentCandidateUnreadMessagesDocument, useGetCurrentCandidateUnreadMessagesLazyQuery, GetCurrentCandidateWhatsAppNotificationStatusDocument, useGetCurrentCandidateWhatsAppNotificationStatusLazyQuery, GetFocusSuggestionsDocument, useGetFocusSuggestionsLazyQuery, GetRegisterSuggestionsDocument, useGetRegisterSuggestionsLazyQuery, ImportLinkedinProfileDocument, useImportLinkedinProfileLazyQuery, ListCareersDocument, useListCareersLazyQuery, ShowCandidateProfileDocument, useShowCandidateProfileQuery, useShowCandidateProfileLazyQuery, CheckPasswordDocument, useCheckPasswordLazyQuery, CheckTwoFactorAuthenticationCodeDocument, useCheckTwoFactorAuthenticationCodeLazyQuery, GetAccountManagerInfoForHeaderDocument, useGetAccountManagerInfoForHeaderLazyQuery, GetActiveFocusesDocument, useGetActiveFocusesLazyQuery, GetCandidateFilterOptionsByIdDocument, useGetCandidateFilterOptionsByIdLazyQuery, GetCandidateFilterSelectOptionsDocument, useGetCandidateFilterSelectOptionsLazyQuery, GetCitiesSuggestionsDocument, useGetCitiesSuggestionsQuery, useGetCitiesSuggestionsLazyQuery, GetCityByIdsDocument, useGetCityByIdsQuery, useGetCityByIdsLazyQuery, GetCompanyAccountInfoForHeaderDocument, useGetCompanyAccountInfoForHeaderLazyQuery, GetCompanyUserScheduleInfoDocument, useGetCompanyUserScheduleInfoQuery, useGetCompanyUserScheduleInfoLazyQuery, GetCurrentActiveJobsSearchCandidatesDocument, useGetCurrentActiveJobsSearchCandidatesLazyQuery, GetCurrentCompanyUserDocument, useGetCurrentCompanyUserLazyQuery, GetCurrentCompanyUserBasicInfoDocument, useGetCurrentCompanyUserBasicInfoLazyQuery, GetCurrentCompanyUserCompanyCitiesDocument, useGetCurrentCompanyUserCompanyCitiesQuery, useGetCurrentCompanyUserCompanyCitiesLazyQuery, GetCurrentCompanyUserIsConfirmedDocument, useGetCurrentCompanyUserIsConfirmedLazyQuery, GetGupyIntegrationDocument, useGetGupyIntegrationLazyQuery, GetTechnologiesSuggestionsDocument, useGetTechnologiesSuggestionsQuery, useGetTechnologiesSuggestionsLazyQuery, GetTechnologyByIdsDocument, useGetTechnologyByIdsQuery, useGetTechnologyByIdsLazyQuery, CountHubPositionsByCompanyDocument, useCountHubPositionsByCompanyQuery, GetHubPositionsByCompanyDocument, ListIndustriesDocument, useListIndustriesQuery, useListIndustriesLazyQuery, ListNumberOfDevelopersOptionsDocument, useListNumberOfDevelopersOptionsQuery, useListNumberOfDevelopersOptionsLazyQuery, MetabaseEmbedDashboardUrlDocument, useMetabaseEmbedDashboardUrlQuery, useMetabaseEmbedDashboardUrlLazyQuery, SearchCandidatesDocument, useSearchCandidatesQuery, SearchCandidatesTotalsDocument, useSearchCandidatesTotalsQuery, SearchLanguagesDocument, useSearchLanguagesQuery, useSearchLanguagesLazyQuery, ValidateCompanyRegistrationDocument, useValidateCompanyRegistrationQuery, useValidateCompanyRegistrationLazyQuery, FindActiveJobsByCompanyUserWhoIsResponsibleDocument, useFindActiveJobsByCompanyUserWhoIsResponsibleLazyQuery, FindPendingBidsByCompanyUserWhoIsResponsibleDocument, useFindPendingBidsByCompanyUserWhoIsResponsibleLazyQuery, FindScheduledInterviewsByCompanyUserWhoIsResponsibleDocument, useFindScheduledInterviewsByCompanyUserWhoIsResponsibleLazyQuery, GetAllCompanyUsersFromCurrentCompanyDocument, useGetAllCompanyUsersFromCurrentCompanyLazyQuery, GetCompanyUserByIdDocument, useGetCompanyUserByIdLazyQuery, GetFeatureFlagDocument, useGetFeatureFlagQuery, useGetFeatureFlagLazyQuery, FindActiveAndApprovedJobsDocument, useFindActiveAndApprovedJobsQuery, useFindActiveAndApprovedJobsLazyQuery, FindFirstJobBySlugDocument, useFindFirstJobBySlugQuery, useFindFirstJobBySlugLazyQuery, FindLatestApprovedJobsDocument, useFindLatestApprovedJobsQuery, useFindLatestApprovedJobsLazyQuery, FindMaxMinJobsSalaryDocument, useFindMaxMinJobsSalaryLazyQuery, FindShowcaseJobsDocument, useFindShowcaseJobsQuery, FindSimilarJobsDocument, useFindSimilarJobsQuery, useFindSimilarJobsLazyQuery, GetScreeningByJobIdDocument, useGetScreeningByJobIdLazyQuery, ListCountriesAndCitiesDocument, useListCountriesAndCitiesQuery, useListCountriesAndCitiesLazyQuery, ListSubscriptionPlansDocument, useListSubscriptionPlansQuery, useListSubscriptionPlansLazyQuery, SearchCitiesDocument, SearchCompanyAliasDocument, useSearchCompanyAliasLazyQuery, SearchTechsDocument */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67595);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4306);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18077);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76778);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RegisterAmplitudeHit($amplitudeHitType: AmplitudeHitOptionsEnum!, $userEmail: String, $userType: AmplitudeUserTypeEnum!, $anonymous: Boolean) {\n  registerAmplitudeHit(\n    amplitudeHitType: $amplitudeHitType\n    userEmail: $userEmail\n    userType: $userType\n    anonymous: $anonymous\n  ) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RegisterAmplitudeHitAuthenticated($amplitudeHitType: AmplitudeHitOptionsEnum!) {\n  registerAmplitudeHitAuthenticated(amplitudeHitType: $amplitudeHitType) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepAbout($positionTitle: String!, $summary: String!, $excludedCompaniesAttributes: [CandidateExcludedCompaniesAttributes!]) {\n  registerCandidateStepAbout(\n    params: {positionTitle: $positionTitle, summary: $summary, excludedCompaniesAttributes: $excludedCompaniesAttributes}\n  ) {\n    success\n    candidate {\n      id\n      positionTitle\n      summary\n      candidateExcludedCompanies {\n        id\n        companyAlias {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepCareer($workRemote: String!, $pjSalary: Float, $cltSalary: Float, $usdSalary: Float, $candidateCitiesAttributes: [CandidateCitiesAttributes!]) {\n  registerCandidateStepCareer(\n    params: {workRemote: $workRemote, pjSalary: $pjSalary, cltSalary: $cltSalary, usdSalary: $usdSalary, candidateCitiesAttributes: $candidateCitiesAttributes}\n  ) {\n    success\n    candidate {\n      id\n      workRemote\n      pjSalary\n      cltSalary\n      usdSalary\n      candidateCities {\n        city {\n          id\n          name\n        }\n        order\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepExperiences($noExperiences: Boolean!, $experiencesAttributes: [ExperiencesAttributes!], $educationsAttributes: [EducationsAttributes!]!, $certificationsAttributes: [CertificationsAttributes!], $projectsAttributes: [ProjectsAttributes!]) {\n  registerCandidateStepExperiences(\n    params: {noExperiences: $noExperiences, experiencesAttributes: $experiencesAttributes, educationsAttributes: $educationsAttributes, certificationsAttributes: $certificationsAttributes, projectsAttributes: $projectsAttributes}\n  ) {\n    success\n    candidate {\n      id\n      noExperiences\n      experiences {\n        company\n        currentJob\n        description\n        endDate\n        id\n        jobTitle\n        startDate\n        skills {\n          id\n          level {\n            value\n          }\n          mainTech\n          order\n          technology {\n            id\n            name\n          }\n        }\n      }\n      educations {\n        course\n        educationStatus\n        endYear\n        id\n        institution\n        startYear\n        title {\n          value\n        }\n      }\n      certifications {\n        current\n        endDate\n        id\n        institution\n        startDate\n        title\n        url\n      }\n      projects {\n        current\n        description\n        endDate\n        id\n        name\n        startDate\n        url\n      }\n      candidateExcludedCompanies {\n        id\n        companyAlias {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepImage($params: CandidateRegisterStepImage!) {\n  registerCandidateStepImage(params: $params) {\n    candidate {\n      id\n      image\n    }\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepLinkedin($params: CandidateRegisterStepLinkedin!) {\n  registerCandidateStepLinkedin(params: $params) {\n    candidate {\n      id\n      searchStatus\n      linkedInUrl\n      hiringOption\n    }\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepProfile($params: CandidateRegisterStepProfile!) {\n  registerCandidateStepProfile(params: $params) {\n    success\n    candidate {\n      id\n      name\n      email\n      phone\n      city {\n        id\n        name\n      }\n      gender\n      specialNecessity\n      stackoverflowUrl\n      githubUrl\n      allowWhatsappNotification\n      portfolioUrl\n      portfolioExtraUrl\n    }\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CandidateRegisterStepSkills($params: CandidateRegisterStepSkills!) {\n  registerCandidateStepSkills(params: $params) {\n    success\n    candidate {\n      id\n      workedUsingOnlyEnglish\n      candidateFocus {\n        order\n        experienceLevel {\n          value\n        }\n        focus {\n          id\n          description\n          career {\n            name\n            id\n            slug\n            worksWithSkills\n          }\n        }\n      }\n      skills {\n        id\n        level {\n          value\n        }\n        mainTech\n        order\n        technology {\n          id\n          name\n        }\n      }\n      experiences {\n        company\n        currentJob\n        description\n        endDate\n        id\n        jobTitle\n        startDate\n        skills {\n          id\n          level {\n            value\n          }\n          mainTech\n          order\n          technology {\n            id\n            name\n          }\n        }\n      }\n      candidateLanguages {\n        language {\n          id\n          name\n        }\n        readingLevel {\n          value\n        }\n        talkingLevel {\n          value\n        }\n        writingLevel {\n          value\n        }\n        assessmentLevel\n        updatedAt\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    mutation UpdateCandidate($payload: CandidateInput!) {\n  updateCandidate(payload: $payload) {\n    cltSalary\n    pjSalary\n    usdSalary\n    hiringOption\n    skills {\n      id\n      level {\n        value\n      }\n      mainTech\n      order\n      technology {\n        id\n        name\n      }\n    }\n    candidateLanguages {\n      language {\n        id\n        name\n      }\n      readingLevel {\n        value\n      }\n      talkingLevel {\n        value\n      }\n      writingLevel {\n        value\n      }\n      assessmentLevel\n      updatedAt\n    }\n    searchStatus\n    available\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCurrentCandidateActivityLog($eventType: ActivityLogEventTypeEnum!) {\n  createCurrentCandidateActivityLog(eventType: $eventType) {\n    id\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCurrentCandidateAvailableFeedback($available: Boolean!, $feedbackType: AvailableFeedbackEnum!, $message: String) {\n  createCurrentCandidateAvailableFeedback(\n    available: $available\n    feedbackType: $feedbackType\n    message: $message\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RegisterCandidateFirstStep($termsOfService: Boolean!, $email: String!, $emailNotification: Boolean!, $name: String!, $password: String!, $firstReferer: String, $fromReferral: String, $utmSource: String!, $utmMedium: String!, $utmCampaign: String!, $utmTerm: String, $deviceType: String, $lastRenderedSlug: String) {\n  registerCandidateFirstStep(\n    candidateParams: {termsOfService: $termsOfService, email: $email, emailNotification: $emailNotification, name: $name, password: $password, firstReferer: $firstReferer, fromReferral: $fromReferral, lastRenderedSlug: $lastRenderedSlug}\n    trackConversionParams: {utmSource: $utmSource, utmMedium: $utmMedium, utmCampaign: $utmCampaign, utmTerm: $utmTerm, deviceType: $deviceType}\n  ) {\n    candidate {\n      id\n      name\n      email\n    }\n    authToken\n    errors\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SetCurrentCandidateDashboardFirstAccess($isDashboardFirstAccess: Boolean!) {\n  setCurrentCandidateDashboardFirstAccess(\n    isDashboardFirstAccess: $isDashboardFirstAccess\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SetCurrentCandidateStatus($searchStatus: SearchStatusEnum!, $available: Boolean!) {\n  setCurrentCandidateStatus(searchStatus: $searchStatus, available: $available) {\n    id\n    available\n    searchStatus\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SetCurrentCandidateWhatsappNotification($allowWhatsappNotification: Boolean!) {\n  setCurrentCandidateWhatsappNotification(\n    allowWhatsappNotification: $allowWhatsappNotification\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateProspect($name: String!, $email: String!, $countryId: ID!, $phone: String!) {\n  createProspect(name: $name, email: $email, countryId: $countryId, phone: $phone) {\n    alreadyAClient\n    id\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n    mutation PurchasePlan($params: Purchase!) {\n  purchasePlan(params: $params) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    mutation AcceptCompanyUserTermsOfService {\n  acceptCompanyUserTermsOfService {\n    redirectUrl\n  }\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CompanyCancelSubscription {\n  companyCancelSubscription {\n    ok\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CompanyRequestUpgrade($searchPool: SearchPoolFilterEnum, $planUpgradeTrigger: CompanyPlanUpgradeTriggerEnum, $targetTier: TierEnum) {\n  companyRequestUpgrade(\n    searchPool: $searchPool\n    planUpgradeTrigger: $planUpgradeTrigger\n    targetTier: $targetTier\n  ) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateBid($bidInputParams: BidInput!) {\n  createBid(bidInputParams: $bidInputParams) {\n    id\n  }\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateNote($noteInputParams: NoteInput!) {\n  createNote(noteInputParams: $noteInputParams) {\n    id\n    note\n    actorName\n    excluded\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateScreeningCandidate($inputScreeningCandidate: ScreeningCandidateInput!) {\n  createScreeningCandidate(inputScreeningCandidate: $inputScreeningCandidate) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    mutation DisableTwoFactorAuthentication {\n  disableTwoFactorAuthentication {\n    ok\n  }\n}\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    mutation EnableTwoFactorAuthentication {\n  enableTwoFactorAuthentication {\n    ok\n  }\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    mutation GenerateTwoFactorAuthenticationSecret {\n  generateTwoFactorAuthenticationSecret {\n    ok\n  }\n}\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n    mutation RejectCandidateInterestJob($id: ID!) {\n  rejectCandidateInterestJob(id: $id) {\n    success\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n    mutation ScheduleDemonstration($id: Int!, $notifySales: Boolean!, $preferredContactForm: String, $type: ScheduleTypeEnum) {\n  scheduleDemonstration(\n    id: $id\n    notifySales: $notifySales\n    preferredContactForm: $preferredContactForm\n    type: $type\n  ) {\n    company {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SendUserEmailConfirmationInstructions {\n  sendCompanyUserEmailConfirmationInstructions {\n    ok\n  }\n}\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n    mutation ToggleFavoriteCandidate($candidateId: Int!, $companyUserId: Int!) {\n  toggleFavoriteCandidate(\n    candidateId: $candidateId\n    companyUserId: $companyUserId\n  ) {\n    isFavorite\n  }\n}\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n    mutation ToggleHiddenCandidate($candidateId: Int!, $companyUserId: Int!) {\n  toggleHiddenCandidate(candidateId: $candidateId, companyUserId: $companyUserId) {\n    isHidden\n  }\n}\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n    mutation UpdateCompanyCandidateSearchResultClicked($searchId: ID!, $candidateId: ID!) {\n  updateCompanyCandidateSearchResultClicked(\n    searchId: $searchId\n    candidateId: $candidateId\n  )\n}\n    "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n    mutation UpdateNote($noteUpdateParams: NoteUpdate!) {\n  updateNote(noteUpdateParams: $noteUpdateParams) {\n    note\n    excluded\n  }\n}\n    "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n    mutation UpdatePartnerIntegration($id: ID!, $params: UpdatePartnerIntegration!) {\n  updatePartnerIntegration(id: $id, params: $params) {\n    id\n    domain\n    token\n  }\n}\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCompanyUser($params: CreateOrUpdateCompanyUserInput!) {\n  createCompanyUser(params: $params) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCompanyUserActivityLog($eventType: CompanyUserActivityLogEventTypeEnum!) {\n  createCompanyUserActivityLog(eventType: $eventType) {\n    id\n  }\n}\n    "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n    mutation SwitchCompanyUserLanguage($language: String!) {\n  switchCompanyUserLanguage(language: $language) {\n    language\n  }\n}\n    "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n    mutation ToggleActive($params: CompanyUserToggleActiveInput!) {\n  toggleActive(params: $params) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n    mutation UpdateCompanyUser($id: ID!, $params: CreateOrUpdateCompanyUserInput!) {\n  updateCompanyUser(id: $id, params: $params) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n    mutation CreateCurrentCandidateInterestJob($jobId: Int!, $interestType: String!) {\n  createCurrentCandidateInterestJob(\n    params: {jobId: $jobId, interestType: $interestType}\n  ) {\n    candidateInterestJob {\n      id\n      interestType\n      candidateId\n      job {\n        id\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n    query CheckCandidateIsRegistered($email: String!) {\n  checkCandidateIsRegistered(candidateEmail: $email) {\n    isRegistered\n  }\n}\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCandidateProfileData {\n  getCandidateProfileData {\n    candidate {\n      id\n      image\n      linkedInUrl\n      searchStatus\n      workRemote\n      workedUsingOnlyEnglish\n      isDashboardFirstAccess\n      candidateCities {\n        city {\n          id\n          name\n        }\n        order\n      }\n      cltSalary\n      pjSalary\n      usdSalary\n      candidateFocus {\n        order\n        experienceLevel {\n          value\n        }\n        focus {\n          id\n          description\n          career {\n            name\n            id\n            slug\n            worksWithSkills\n          }\n        }\n      }\n      skills {\n        id\n        level {\n          value\n        }\n        mainTech\n        order\n        technology {\n          id\n          name\n        }\n      }\n      candidateLanguages {\n        language {\n          id\n          name\n        }\n        assessmentLevel\n        readingLevel {\n          value\n        }\n        talkingLevel {\n          value\n        }\n        writingLevel {\n          value\n        }\n        updatedAt\n      }\n      noExperiences\n      experiences {\n        company\n        currentJob\n        description\n        endDate\n        id\n        jobTitle\n        startDate\n        skills {\n          id\n          level {\n            value\n          }\n          mainTech\n          order\n          technology {\n            id\n            name\n          }\n        }\n      }\n      educations {\n        course\n        educationStatus\n        endYear\n        id\n        institution\n        startYear\n        title {\n          value\n        }\n      }\n      certifications {\n        current\n        endDate\n        id\n        institution\n        startDate\n        title\n        url\n      }\n      projects {\n        current\n        description\n        endDate\n        id\n        name\n        startDate\n        url\n      }\n      positionTitle\n      summary\n      candidateExcludedCompanies {\n        id\n        companyAlias {\n          id\n          name\n        }\n      }\n      image\n      name\n      email\n      phone\n      city {\n        id\n        name\n      }\n      gender\n      specialNecessity\n      stackoverflowUrl\n      githubUrl\n      allowWhatsappNotification\n      hiringOption\n      available\n      situation\n      portfolioUrl\n      portfolioExtraUrl\n      techCareer\n    }\n  }\n}\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateAvailable {\n  getCurrentCandidate {\n    id\n    available\n    searchStatus\n  }\n}\n    "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateBasicInfo {\n  getCurrentCandidate {\n    id\n    name\n    email\n    phone\n    hiringOption\n    isDashboardFirstAccess\n  }\n}\n    "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateHiring {\n  getCurrentCandidateHiring {\n    id\n    company {\n      id\n      name\n    }\n    candidateSalary\n    job {\n      id\n      title\n      isInternational\n    }\n    createdAt\n  }\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateImage {\n  getCurrentCandidate {\n    id\n    image\n  }\n}\n    "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateInterestJobsByJobIds($jobs: [Int!]!) {\n  getCurrentCandidateInterestJobsByJobIds(jobIds: $jobs) {\n    id\n    job {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateMainInfo {\n  getCurrentCandidate {\n    id\n    pjSalary\n    cltSalary\n    usdSalary\n    workRemote\n    image\n    hiringOption\n    situation\n    candidateCities {\n      order\n      city {\n        id\n        name\n      }\n    }\n    skills {\n      id\n      mainTech\n      technology {\n        id\n        name\n      }\n    }\n    candidateLanguages {\n      readingLevel {\n        value\n      }\n      talkingLevel {\n        value\n      }\n      writingLevel {\n        value\n      }\n      language {\n        id\n        name\n      }\n    }\n    candidateFocus {\n      focus {\n        career {\n          name\n          id\n          slug\n          worksWithSkills\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateMd5Email {\n  getCurrentCandidate {\n    id\n    md5Email\n  }\n}\n    "
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidatePendingBids {\n  getCurrentCandidatePendingBids {\n    id\n    createdAt\n    company {\n      id\n      name\n    }\n  }\n}\n    "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidatePendingInterviews {\n  getCurrentCandidatePendingInterviews {\n    id\n    start\n    end\n    eventType\n    company {\n      id\n      name\n    }\n    companyUser {\n      id\n      name\n    }\n    bid {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateUnreadMessages {\n  getCurrentCandidateUnreadMessages {\n    id\n    company {\n      id\n      name\n    }\n  }\n}\n    "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCandidateWhatsAppNotificationStatus {\n  getCurrentCandidate {\n    id\n    allowWhatsappNotification\n  }\n}\n    "
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n    query GetFocusSuggestions($careerSlug: String, $onlyActiveJobs: Boolean) {\n  getFocusSuggestions(careerSlug: $careerSlug, onlyActiveJobs: $onlyActiveJobs) {\n    focus {\n      id\n      description\n      career {\n        worksWithSkills\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n    query GetRegisterSuggestions($careerSlug: CareerSlugEnum) {\n  getRegisterSuggestions(careerSlug: $careerSlug) {\n    cities {\n      name\n      id\n    }\n    techs {\n      name\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n    query ImportLinkedinProfile($linkedinProfileUrl: String!) {\n  importLinkedinProfile(linkedinProfileUrl: $linkedinProfileUrl) {\n    fullName\n    occupation\n    headline\n    summary\n    experiences {\n      company\n      title\n      description\n      location\n      startsAt {\n        month\n        year\n      }\n      endsAt {\n        month\n        year\n      }\n    }\n    education {\n      startsAt {\n        month\n        year\n      }\n      endsAt {\n        month\n        year\n      }\n      fieldOfStudy\n      degreeName\n      school\n      description\n    }\n    accomplishmentProjects {\n      startsAt {\n        month\n        year\n      }\n      endsAt {\n        month\n        year\n      }\n      title\n      description\n      url\n    }\n    certifications {\n      startsAt {\n        month\n        year\n      }\n      endsAt {\n        month\n        year\n      }\n      url\n      name\n      displaySource\n      authority\n    }\n  }\n}\n    "
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n    query ListCareers {\n  listCareers {\n    name\n    id\n    slug\n    worksWithSkills\n  }\n}\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n    query ShowCandidateProfile($candidateId: Int!) {\n  showCandidateProfile(candidateId: $candidateId) {\n    candidate {\n      id\n      name\n      image\n      positionTitle\n      cltSalary\n      pjSalary\n      usdSalary\n      lastApprovedTime\n      approvedInternational\n      searchStatus\n      city {\n        id\n        name\n      }\n      summary\n      summaryTranslation\n      techEvaluations {\n        evaluatedAt\n        score\n        skills\n        kind\n        pdfUrl\n      }\n      workRemote\n      localWorkPreference\n      specialNecessity\n      humanizedSpecialNecessity\n      workedUsingOnlyEnglish\n      geekhunterEvaluation\n      geekhunterEvaluationTranslation\n      geekhunterEvaluatedAt\n      searchPools\n      stackoverflowUrl\n      githubUrl\n      linkedInUrl\n      portfolioUrl\n      portfolioExtraUrl\n      available\n      situation\n      phone\n      email\n      allowWhatsappNotification\n      hiringOption\n      profileLanguage\n      candidateLanguages {\n        assessmentLevel\n        id\n        language {\n          id\n          name\n        }\n        talkingLevel {\n          value\n        }\n        updatedAt\n      }\n      experiences {\n        id\n        company\n        startDate\n        endDate\n        currentJob\n        jobTitle\n        durationInMonths\n        description\n        descriptionTranslation\n        skills {\n          technology {\n            name\n          }\n        }\n      }\n      skills {\n        id\n        level {\n          value\n          text\n        }\n        mainTech\n        technology {\n          id\n          name\n        }\n        evaluationCount\n      }\n      educations {\n        id\n        institution\n        educationStatus\n        startYear\n        endYear\n        durationInYears\n        course\n      }\n      certifications {\n        id\n        institution\n        startDate\n        endDate\n        url\n        current\n        title\n      }\n      projects {\n        id\n        name\n        description\n        url\n        startDate\n        endDate\n        current\n      }\n      candidateFocus {\n        id\n        focus {\n          id\n          description\n        }\n        experienceLevel {\n          value\n          text\n        }\n        order\n      }\n      candidateCities {\n        id\n        order\n        city {\n          id\n          name\n        }\n      }\n    }\n    bidsSent {\n      job {\n        title\n        id\n      }\n      cltMinSalary\n      cltMaxSalary\n      pjMinSalary\n      pjMaxSalary\n      usdAnnualMinSalary\n      usdAnnualMaxSalary\n      status\n      createdAt\n      companyUser {\n        name\n      }\n      id\n      acceptedAt\n      company {\n        name\n      }\n    }\n    notes {\n      id\n      note\n      actorName\n      excluded\n    }\n    isFavoriteCandidate\n    isCandidateHidden\n    hasMessage\n    isBidden\n    candidateInterestJobs {\n      id\n      candidateId\n      status\n      createdAt\n      job {\n        id\n        title\n      }\n      interestType\n    }\n    activeStepCandidates {\n      id\n      step {\n        title\n      }\n      bid {\n        job {\n          title\n        }\n      }\n    }\n    archivedStepCandidates {\n      id\n      step {\n        title\n      }\n      bid {\n        job {\n          title\n        }\n      }\n    }\n    archivedStepCandidateFeedbacks {\n      feedbackType {\n        value\n        label\n      }\n      archivedStepCandidate {\n        stepCandidate {\n          id\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n    query CheckPassword($password: String!) {\n  checkPassword(password: $password)\n}\n    "
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n    query CheckTwoFactorAuthenticationCode($code: String!) {\n  checkTwoFactorAuthenticationCode(code: $code)\n}\n    "
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _taggedTemplateLiteral([
        "\n    query GetAccountManagerInfoForHeader {\n  getCurrentAccountManager {\n    name\n    email\n    image\n    phone\n    scheduleUrl\n  }\n}\n    "
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _taggedTemplateLiteral([
        "\n    query GetActiveFocuses($careerSlugs: [CareerSlugEnum!], $availableForCandidateSearch: Boolean, $availableForCandidates: Boolean) {\n  getActiveFocuses(\n    careerSlugs: $careerSlugs\n    availableForCandidateSearch: $availableForCandidateSearch\n    availableForCandidates: $availableForCandidates\n  ) {\n    id\n    description\n    career {\n      id\n      name\n      slug\n      worksWithSkills\n    }\n  }\n}\n    "
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCandidateFilterOptionsById($cityIds: [ID!]!, $techIds: [ID!]!, $shouldGetCities: Boolean!, $shouldGetTechs: Boolean!) {\n  getCityByIds(ids: $cityIds) @include(if: $shouldGetCities) {\n    id\n    name\n  }\n  getTechnologyByIds(ids: $techIds) @include(if: $shouldGetTechs) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCandidateFilterSelectOptions($careerSlugs: [CareerSlugEnum!], $availableForCandidateSearch: Boolean) {\n  getTechnologiesSuggestions {\n    id\n    name\n  }\n  getCitiesSuggestions {\n    id\n    name\n  }\n  getActiveFocuses(\n    careerSlugs: $careerSlugs\n    availableForCandidateSearch: $availableForCandidateSearch\n  ) {\n    id\n    description\n    career {\n      id\n      name\n      slug\n      worksWithSkills\n    }\n  }\n}\n    "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCitiesSuggestions {\n  getCitiesSuggestions {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCityByIds($ids: [ID!]!) {\n  getCityByIds(ids: $ids) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCompanyAccountInfoForHeader {\n  getCurrentCompanyUser {\n    id\n    name\n    company {\n      id\n      name\n      logo\n      isInternational\n      currentTier\n      registrationFlow\n    }\n  }\n  getCurrentPackageInfo {\n    id\n    startAt\n    endAt\n    hiringCount\n    remainingPositions\n    remainingDuration {\n      diff\n      diffType\n    }\n    packageSize\n    packagePlan\n  }\n}\n    "
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCompanyUserScheduleInfo {\n  getCurrentCompanyUser {\n    id\n    email\n    phoneNumber\n    company {\n      id\n      teamMember {\n        id\n        scheduleUrl\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _taggedTemplateLiteral([
        "\n    query getCurrentActiveJobsSearchCandidates {\n  getCurrentActiveJobsSearchCandidates {\n    id\n    job {\n      id\n      slug\n      title\n      requiredEnglish\n      remoteWork\n      hybrid\n      cityId\n      cltMinSalary\n      cltMaxSalary\n      pjMinSalary\n      pjMaxSalary\n      usdAnnualSalaryMin\n      usdAnnualSalaryMax\n      focusId\n      technologies {\n        id\n        name\n      }\n      lastBidMessage\n    }\n    maxSalary\n    companyUserName\n  }\n}\n    "
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCompanyUser {\n  getCurrentCompanyUser {\n    company {\n      id\n      cities {\n        id\n        name\n        priority\n        state {\n          id\n          name\n          abbreviation\n        }\n      }\n      companyPackages {\n        id\n        startAt\n        endAt\n        revenue\n        status\n        packagePlan {\n          slug\n        }\n        automaticRenewal\n      }\n      name\n      segmentation\n      status\n      demo\n      isInternalCompany\n      isInternational\n      hasAccessToGupyIntegration\n      hasActivePlan\n      hasPausedPackage\n      unrestrictedView\n      pausedPackage {\n        id\n        pauseStartAt\n        pauseEndAt\n      }\n      teamMember {\n        email\n      }\n      currentTier\n      features {\n        showSalary\n        showEnglishVetting\n        showProfileTranslation\n        showTechVetting\n        searchPoolSelectedByIa\n        searchPoolGeekhunterApproved\n        showRecommendations\n        standard3Jobs\n        showWorkAvailability\n        showSocialNetworks\n        addNewUsers\n        diversityFilter\n        accessToAccountManager\n        accessCompanyUserRoles\n        accessToHub\n        accessToAts\n      }\n      registrationFlow\n      logo\n    }\n    confirmationSentAt\n    confirmedAt\n    createdAt\n    currentSignInAt\n    currentSignInIp\n    email\n    failedAttempts\n    firstReferer\n    id\n    jobTitle\n    lastSignInAt\n    lastSignInIp\n    lockedAt\n    md5Email\n    name\n    phoneNumber\n    receiveNotifications\n    rememberCreatedAt\n    role\n    signInCount\n    termsOfService\n    unconfirmedEmail\n    updatedAt\n    utmCampaign\n    utmMedium\n    utmSource\n    utmTerm\n    otpRequiredForLogin\n    twoFactorAuthenticationIsConfigured\n    twoFactorAuthenticationQrCodeUri\n    accessHub\n  }\n}\n    "
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCompanyUserBasicInfo {\n  getCurrentCompanyUser {\n    id\n    email\n    name\n    phoneNumber\n    company {\n      id\n      name\n      isInternational\n    }\n  }\n  getCurrentPackageInfo {\n    id\n    packagePlan\n  }\n}\n    "
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCompanyUserCompanyCities {\n  getCurrentCompanyUser {\n    id\n    company {\n      id\n      cities {\n        id\n        name\n        priority\n        state {\n          id\n          name\n          abbreviation\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCurrentCompanyUserIsConfirmed {\n  getCurrentCompanyUser {\n    id\n    confirmedAt\n  }\n}\n    "
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _taggedTemplateLiteral([
        "\n    query GetGupyIntegration {\n  getGupyIntegration {\n    id\n    domain\n    token\n    active\n    hasAgreedToTerms\n  }\n}\n    "
    ]);
    _templateObject74 = function _templateObject74() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _taggedTemplateLiteral([
        "\n    query GetTechnologiesSuggestions {\n  getTechnologiesSuggestions {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject75 = function _templateObject75() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _taggedTemplateLiteral([
        "\n    query GetTechnologyByIds($ids: [ID!]!) {\n  getTechnologyByIds(ids: $ids) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject76 = function _templateObject76() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _taggedTemplateLiteral([
        "\n    query CountHubPositionsByCompany($keyword: String) {\n  countHubPositionsByCompany(keyword: $keyword)\n}\n    "
    ]);
    _templateObject77 = function _templateObject77() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _taggedTemplateLiteral([
        "\n    query GetHubPositionsByCompany($page: Int, $perPage: Int, $keyword: String) {\n  getHubPositionsByCompany(page: $page, perPage: $perPage, keyword: $keyword) {\n    id\n    name\n    post\n    seniority\n    level\n    salary\n    internalRole\n    origin\n    focus {\n      id\n      description\n    }\n    jobSalaries {\n      minSalary\n      maxSalary\n    }\n    hubSalaryStatistic {\n      median\n      mean\n      min\n      max\n      numberOfSamples\n      basis\n    }\n  }\n}\n    "
    ]);
    _templateObject78 = function _templateObject78() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _taggedTemplateLiteral([
        "\n    query ListIndustries {\n  industries {\n    id\n    name\n    active\n  }\n}\n    "
    ]);
    _templateObject79 = function _templateObject79() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _taggedTemplateLiteral([
        "\n    query ListNumberOfDevelopersOptions {\n  numberOfProgrammersOptions {\n    key\n    value\n  }\n}\n    "
    ]);
    _templateObject80 = function _templateObject80() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _taggedTemplateLiteral([
        "\n    query MetabaseEmbedDashboardUrl($dashboard: Int!, $role: String!) {\n  metabaseEmbedDashboardUrl(dashboard: $dashboard, role: $role)\n}\n    "
    ]);
    _templateObject81 = function _templateObject81() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _taggedTemplateLiteral([
        "\n    query SearchCandidates($filters: SearchCandidateFilter!, $searchId: ID, $onlyTotals: Boolean) {\n  searchCandidates(\n    filters: $filters\n    companyCandidateSearchId: $searchId\n    onlyTotals: $onlyTotals\n  ) {\n    candidates {\n      candidate {\n        id\n        name\n        image\n        positionTitle\n        cltSalary\n        pjSalary\n        usdSalary\n        lastApprovedTime\n        approvedInternational\n        city {\n          id\n          name\n        }\n        summary\n        workRemote\n        localWorkPreference\n        specialNecessity\n        humanizedSpecialNecessity\n        experiences {\n          id\n          company\n          startDate\n          endDate\n          currentJob\n        }\n        skills {\n          id\n          level {\n            value\n            text\n          }\n          mainTech\n          technology {\n            id\n            name\n          }\n        }\n        educations {\n          id\n          institution\n          educationStatus\n          endYear\n        }\n        candidateFocus {\n          id\n          focus {\n            id\n            description\n          }\n          experienceLevel {\n            value\n            text\n          }\n          order\n        }\n        candidateCities {\n          id\n          order\n          city {\n            id\n            name\n          }\n        }\n        candidateLanguages {\n          language {\n            id\n            name\n          }\n          assessmentLevel\n          readingLevel {\n            value\n          }\n          talkingLevel {\n            value\n          }\n          writingLevel {\n            value\n          }\n          updatedAt\n        }\n        searchPools\n      }\n      lastBidSent {\n        id\n        status\n        createdAt\n        companyUser {\n          id\n          name\n        }\n      }\n      isFavorite\n      lastTimeViewed\n      notes {\n        note\n        createdAt\n        actor {\n          ... on CompanyUser {\n            name\n          }\n        }\n      }\n    }\n    totalFilteredCount\n    isDefaultSearch\n    companyCandidateSearchId\n  }\n}\n    "
    ]);
    _templateObject82 = function _templateObject82() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _taggedTemplateLiteral([
        "\n    query SearchCandidatesTotals($filters: SearchCandidateFilter!, $searchId: ID, $onlyTotals: Boolean) {\n  searchCandidates(\n    filters: $filters\n    companyCandidateSearchId: $searchId\n    onlyTotals: $onlyTotals\n  ) {\n    totalFilteredCount\n  }\n}\n    "
    ]);
    _templateObject83 = function _templateObject83() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _taggedTemplateLiteral([
        "\n    query searchLanguages($text: String!) {\n  searchLanguages(text: $text) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject84 = function _templateObject84() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _taggedTemplateLiteral([
        "\n    query ValidateCompanyRegistration($companyDomain: String!, $companyName: String!) {\n  validateCompanyRegistration(\n    companyDomain: $companyDomain\n    companyName: $companyName\n  ) {\n    ok\n  }\n}\n    "
    ]);
    _templateObject85 = function _templateObject85() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _taggedTemplateLiteral([
        "\n    query FindActiveJobsByCompanyUserWhoIsResponsible($id: ID!) {\n  findActiveJobsByCompanyUserWhoIsResponsible(id: $id) {\n    id\n  }\n}\n    "
    ]);
    _templateObject86 = function _templateObject86() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _taggedTemplateLiteral([
        "\n    query FindPendingBidsByCompanyUserWhoIsResponsible($id: ID!) {\n  findPendingBidsByCompanyUserWhoIsResponsible(id: $id) {\n    id\n  }\n}\n    "
    ]);
    _templateObject87 = function _templateObject87() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _taggedTemplateLiteral([
        "\n    query FindScheduledInterviewsByCompanyUserWhoIsResponsible($id: ID!) {\n  findScheduledInterviewsByCompanyUserWhoIsResponsible(id: $id) {\n    id\n  }\n}\n    "
    ]);
    _templateObject88 = function _templateObject88() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _taggedTemplateLiteral([
        "\n    query GetAllCompanyUsersFromCurrentCompany {\n  getAllCompanyUsersFromCurrentCompany {\n    id\n    name\n    role\n    email\n    jobTitle\n    receiveNotifications\n    active\n  }\n}\n    "
    ]);
    _templateObject89 = function _templateObject89() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _taggedTemplateLiteral([
        "\n    query GetCompanyUserById($id: ID!) {\n  getCompanyUserById(id: $id) {\n    id\n    name\n    role\n    email\n    jobTitle\n    receiveNotifications\n    phoneNumber\n    active\n    accessHub\n  }\n}\n    "
    ]);
    _templateObject90 = function _templateObject90() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _taggedTemplateLiteral([
        "\n    query GetFeatureFlag($params: GetFeatureFlag!) {\n  getFeatureFlag(params: $params)\n}\n    "
    ]);
    _templateObject91 = function _templateObject91() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _taggedTemplateLiteral([
        "\n    query findActiveAndApprovedJobs {\n  findActiveAndApprovedJobs {\n    id\n    city {\n      id\n      name\n    }\n    cltMaxSalary\n    cltMinSalary\n    createdAt\n    maxSalary\n    pjMaxSalary\n    pjMinSalary\n    remoteWork\n    slug\n    technologies {\n      id\n      name\n      urlPath\n    }\n    title\n    focusId\n    experienceLevel\n    createdAt\n    requirements\n  }\n}\n    "
    ]);
    _templateObject92 = function _templateObject92() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _taggedTemplateLiteral([
        "\n    query findFirstJobBySlug($slug: String!) {\n  findFirstJobBySlug(slug: $slug) {\n    id\n    title\n    experienceLevel\n    active\n    adminApproval\n    cltMaxSalary\n    cltMinSalary\n    createdAt\n    maxSalary\n    pjMaxSalary\n    pjMinSalary\n    usdAnnualSalaryMin\n    usdAnnualSalaryMax\n    remoteWork\n    hybrid\n    slug\n    activities\n    requirements\n    englishLevel\n    description\n    focusId\n    hideSalary\n    hideCompany\n    city {\n      id\n      name\n      state {\n        abbreviation\n      }\n    }\n    jobBenefits {\n      description\n      benefit {\n        name\n        key\n      }\n    }\n    jobTechnologies {\n      id\n      required\n      technology {\n        id\n        name\n        urlPath\n      }\n    }\n    company {\n      summary\n      industry {\n        name\n      }\n      name\n    }\n    isInternational\n    jobType\n    techCareer\n    careerExperienceLevel\n    focusExperienceLevel\n    focus {\n      description\n      career {\n        name\n        slug\n      }\n    }\n    publishedScreening {\n      id\n      questions {\n        id\n        answerType\n        name\n        mandatory\n        minAnswerOptions\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject93 = function _templateObject93() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _taggedTemplateLiteral([
        "\n    query findLatestApprovedJobs($quantity: Int) {\n  findLatestApprovedJobs(quantity: $quantity) {\n    id\n    city {\n      id\n      name\n    }\n    cltMaxSalary\n    cltMinSalary\n    createdAt\n    maxSalary\n    pjMaxSalary\n    pjMinSalary\n    usdAnnualSalaryMin\n    usdAnnualSalaryMax\n    remoteWork\n    hybrid\n    slug\n    hideSalary\n    technologies {\n      id\n      name\n      urlPath\n    }\n    title\n    isInternational\n    jobType\n    company {\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject94 = function _templateObject94() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _taggedTemplateLiteral([
        "\n    query findMaxMinJobsSalary {\n  findMaxMinJobsSalary {\n    minSalary\n    maxSalary\n  }\n}\n    "
    ]);
    _templateObject95 = function _templateObject95() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _taggedTemplateLiteral([
        "\n    query findShowcaseJobs($showcaseParams: SearchJobFilter!) {\n  findShowcaseJobs(showcaseParams: $showcaseParams) {\n    total\n    data {\n      id\n      city {\n        id\n        name\n      }\n      cltMaxSalary\n      cltMinSalary\n      createdAt\n      maxSalary\n      pjMaxSalary\n      pjMinSalary\n      usdAnnualSalaryMin\n      usdAnnualSalaryMax\n      remoteWork\n      slug\n      hideSalary\n      technologies {\n        id\n        name\n        urlPath\n      }\n      title\n      focusId\n      focus {\n        id\n        description\n        career {\n          id\n          name\n        }\n      }\n      experienceLevel\n      requirements\n      description\n      isInternational\n      hybrid\n      techCareer\n      careerExperienceLevel\n      focusExperienceLevel\n      jobType\n      company {\n        slug\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject96 = function _templateObject96() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _taggedTemplateLiteral([
        "\n    query findSimilarJobs($jobId: Int!, $quantity: Int) {\n  findSimilarJobs(jobId: $jobId, quantity: $quantity) {\n    id\n    city {\n      id\n      name\n    }\n    cltMaxSalary\n    cltMinSalary\n    createdAt\n    maxSalary\n    pjMaxSalary\n    pjMinSalary\n    usdAnnualSalaryMin\n    usdAnnualSalaryMax\n    remoteWork\n    hybrid\n    slug\n    hideSalary\n    technologies {\n      id\n      name\n      urlPath\n    }\n    title\n    isInternational\n    jobType\n    company {\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject97 = function _templateObject97() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _taggedTemplateLiteral([
        "\n    query getScreeningByJobId($jobId: Int!, $publishedOnly: Boolean) {\n  getScreeningByJobId(jobId: $jobId, publishedOnly: $publishedOnly) {\n    id\n    questions {\n      id\n      answerType\n      name\n      mandatory\n      minAnswerOptions\n    }\n  }\n}\n    "
    ]);
    _templateObject98 = function _templateObject98() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _taggedTemplateLiteral([
        "\n    query ListCountriesAndCities($textSearch: String!, $limit: Int) {\n  listCountries {\n    id\n    name\n  }\n  searchCities(text: $textSearch, limit: $limit) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject99 = function _templateObject99() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _taggedTemplateLiteral([
        "\n    query ListSubscriptionPlans {\n  listSubscriptionPlans {\n    id\n    name\n    price\n    period\n    slug\n  }\n}\n    "
    ]);
    _templateObject100 = function _templateObject100() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _taggedTemplateLiteral([
        "\n    query SearchCities($textSearch: String!) {\n  searchCities(text: $textSearch) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject101 = function _templateObject101() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _taggedTemplateLiteral([
        "\n    query SearchCompanyAlias($textSearch: String!) {\n  searchCompanyAlias(text: $textSearch) {\n    id\n    name\n    baseCompanyId\n  }\n}\n    "
    ]);
    _templateObject102 = function _templateObject102() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _taggedTemplateLiteral([
        "\n    query SearchTechs($textSearch: String!, $subTypes: [TechnologySubtypeEnum!]) {\n  searchTechs(text: $textSearch, subtypes: $subTypes) {\n    id\n    name\n  }\n}\n    "
    ]);
    _templateObject103 = function _templateObject103() {
        return data;
    };
    return data;
}
var defaultOptions = {};
var ActivityLogEventTypeEnum;
(function(ActivityLogEventTypeEnum) {
    ActivityLogEventTypeEnum["CandidateUnavailable"] = 'candidate_unavailable';
    ActivityLogEventTypeEnum["CandidateAvailable"] = 'candidate_available';
    ActivityLogEventTypeEnum["AdminUnavailable"] = 'admin_unavailable';
    ActivityLogEventTypeEnum["AdminAvailable"] = 'admin_available';
    ActivityLogEventTypeEnum["AdminUnqualified"] = 'admin_unqualified';
    ActivityLogEventTypeEnum["AdminQualified"] = 'admin_qualified';
    ActivityLogEventTypeEnum["WorkerUnavailable"] = 'worker_unavailable';
    ActivityLogEventTypeEnum["WorkerAvailable"] = 'worker_available';
    ActivityLogEventTypeEnum["ErrorOrBatch"] = 'error_or_batch';
    ActivityLogEventTypeEnum["AdminBackInRodada"] = 'admin_back_in_rodada';
    ActivityLogEventTypeEnum["BackToPreviousState"] = 'back_to_previous_state';
    ActivityLogEventTypeEnum["BackToAprovado"] = 'back_to_aprovado';
    ActivityLogEventTypeEnum["CandidateWrongfulState"] = 'candidate_wrongful_state';
    ActivityLogEventTypeEnum["SetGanharDestaque"] = 'set_ganhar_destaque';
    ActivityLogEventTypeEnum["SaveStatusChange"] = 'save_status_change';
    ActivityLogEventTypeEnum["SaveAvailableChange"] = 'save_available_change';
    ActivityLogEventTypeEnum["SaveExamFinish"] = 'save_exam_finish';
    ActivityLogEventTypeEnum["SaveExamTimeExceed"] = 'save_exam_time_exceed';
    ActivityLogEventTypeEnum["UpdateProfile"] = 'update_profile';
    ActivityLogEventTypeEnum["ClickJobList"] = 'click_job_list';
    ActivityLogEventTypeEnum["CleanProfile"] = 'clean_profile';
    ActivityLogEventTypeEnum["JoiningInvisible"] = 'joining_invisible';
    ActivityLogEventTypeEnum["InteractionWithPlatform"] = 'interaction_with_platform';
    ActivityLogEventTypeEnum["DashboardAccess"] = 'dashboard_access';
    ActivityLogEventTypeEnum["LearnMoreInternationalGeek"] = 'learn_more_international_geek';
    ActivityLogEventTypeEnum["SeeJobsInternationalGeek"] = 'see_jobs_international_geek';
    ActivityLogEventTypeEnum["LearnMoreSafetyWing"] = 'learn_more_safety_wing';
})(ActivityLogEventTypeEnum || (ActivityLogEventTypeEnum = {}));
var ActorModelsEnum;
(function(ActorModelsEnum) {
    ActorModelsEnum["Candidate"] = 'candidate';
    ActorModelsEnum["TeamMember"] = 'team_member';
    ActorModelsEnum["CompanyUser"] = 'company_user';
})(ActorModelsEnum || (ActorModelsEnum = {}));
var AmplitudeHitOptionsEnum;
(function(AmplitudeHitOptionsEnum) {
    AmplitudeHitOptionsEnum["LmFlowV1PvLp"] = 'lm_flow_v1_pv_lp';
    AmplitudeHitOptionsEnum["LmFlowV1LpNoEmail"] = 'lm_flow_v1_lp_no_email';
    AmplitudeHitOptionsEnum["LmFlowV1LpEmail"] = 'lm_flow_v1_lp_email';
    AmplitudeHitOptionsEnum["LmFlowV1PvStep_1"] = 'lm_flow_v1_pv_step_1';
    AmplitudeHitOptionsEnum["LmFlowV1Step_1Completed"] = 'lm_flow_v1_step_1_completed';
    AmplitudeHitOptionsEnum["LmFlowV1PvStep_2"] = 'lm_flow_v1_pv_step_2';
    AmplitudeHitOptionsEnum["LmFlowV1Step_2Completed"] = 'lm_flow_v1_step_2_completed';
    AmplitudeHitOptionsEnum["LmFlowV1PvSignupG5"] = 'lm_flow_v1_pv_signup_g5';
    AmplitudeHitOptionsEnum["LmFlowV1ClickG5SwitchedToRemoteWork"] = 'lm_flow_v1_click_g5_switched_to_remote_work';
    AmplitudeHitOptionsEnum["LmFlowV1ClickG5DidntSwitchedToRemoteWork"] = 'lm_flow_v1_click_g5_didnt_switched_to_remote_work';
    AmplitudeHitOptionsEnum["LmFlowV1PvSignupG5Locked"] = 'lm_flow_v1_pv_signup_g5_locked';
    AmplitudeHitOptionsEnum["LmFlowV1PvHiringIntentResult"] = 'lm_flow_v1_pv_hiring_intent_result';
    AmplitudeHitOptionsEnum["LmFlowV1ClickScheduleDemonstration"] = 'lm_flow_v1_click_schedule_demonstration';
    AmplitudeHitOptionsEnum["LmFlowV1ClickPreferredContact"] = 'lm_flow_v1_click_preferred_contact';
    AmplitudeHitOptionsEnum["LmFlowV1PvPreferredContact"] = 'lm_flow_v1_pv_preferred_contact';
    AmplitudeHitOptionsEnum["LmFlowV1ClickPreferredContactCancel"] = 'lm_flow_v1_click_preferred_contact_cancel';
    AmplitudeHitOptionsEnum["LmFlowV1ClickPreferredContactConfirm"] = 'lm_flow_v1_click_preferred_contact_confirm';
    AmplitudeHitOptionsEnum["LmFlowV1PvSchedule"] = 'lm_flow_v1_pv_schedule';
    AmplitudeHitOptionsEnum["LmFlowV1ClickScheduleGoBack"] = 'lm_flow_v1_click_schedule_go_back';
    AmplitudeHitOptionsEnum["LmFlowV1ClickScheduleConfirm"] = 'lm_flow_v1_click_schedule_confirm';
    AmplitudeHitOptionsEnum["LmFlowV1PvDashboardPending"] = 'lm_flow_v1_pv_dashboard_pending';
    AmplitudeHitOptionsEnum["LmFlowV1ClickAddCompanyUser"] = 'lm_flow_v1_click_add_company_user';
    AmplitudeHitOptionsEnum["LmFlowV1ClickUpdateCompanyProfile"] = 'lm_flow_v1_click_update_company_profile';
    AmplitudeHitOptionsEnum["LmFlowV1PvDashboardConfirmMail"] = 'lm_flow_v1_pv_dashboard_confirm_mail';
    AmplitudeHitOptionsEnum["LmFlowV1ClickResendConfirmationMail"] = 'lm_flow_v1_click_resend_confirmation_mail';
    AmplitudeHitOptionsEnum["LmFlowV1PvDashboardBlocked"] = 'lm_flow_v1_pv_dashboard_blocked';
    AmplitudeHitOptionsEnum["LmFlowV1PvDashboardStagnated"] = 'lm_flow_v1_pv_dashboard_stagnated';
    AmplitudeHitOptionsEnum["LmFlowV1ExistentStagnantCompanyContactRequested"] = 'lm_flow_v1_existent_stagnant_company_contact_requested';
    AmplitudeHitOptionsEnum["CandidateSignInModalDeny"] = 'candidate_sign_in_modal_deny';
    AmplitudeHitOptionsEnum["CandidateDashboardIntendedToBecomeInvisible"] = 'candidate_dashboard_intended_to_become_invisible';
    AmplitudeHitOptionsEnum["CandidateDashboardIntendedToBecomeVisible"] = 'candidate_dashboard_intended_to_become_visible';
    AmplitudeHitOptionsEnum["CandidateDashboardv3BecameInvisibleForOwnChoice"] = 'candidate_dashboardv3_became_invisible_for_own_choice';
    AmplitudeHitOptionsEnum["CandidateDashboardv3BecameVisibleForOwnChoice"] = 'candidate_dashboardv3_became_visible_for_own_choice';
    AmplitudeHitOptionsEnum["CandidateDashboardv3IntendedToEditProfileProfessionalMoment"] = 'candidate_dashboardv3_intended_to_edit_profile_professional_moment';
    AmplitudeHitOptionsEnum["CandidateDashboardv3IntendedToEditProfile"] = 'candidate_dashboardv3_intended_to_edit_profile';
    AmplitudeHitOptionsEnum["CandidateDashboardv3Chat"] = 'candidate_dashboardv3_chat';
    AmplitudeHitOptionsEnum["CandidateDashboardv3BidDetails"] = 'candidate_dashboardv3_bid_details';
    AmplitudeHitOptionsEnum["CandidateDashboardv3InterviewDetails"] = 'candidate_dashboardv3_interview_details';
    AmplitudeHitOptionsEnum["CandidateDashboardv3IgnoreWhatsappNotification"] = 'candidate_dashboardv3_ignore_whatsapp_notification';
    AmplitudeHitOptionsEnum["CandidateDashboardv3AcceptedWhatsappNotification"] = 'candidate_dashboardv3_accepted_whatsapp_notification';
    AmplitudeHitOptionsEnum["CandidateDashboardv3SafetyWingClick"] = 'candidate_dashboardv3_safety_wing_click';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2Status"] = 'candidate_completing_profile_v2_status';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2Career"] = 'candidate_completing_profile_v2_career';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2Skills"] = 'candidate_completing_profile_v2_skills';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2Experiences"] = 'candidate_completing_profile_v2_experiences';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2About"] = 'candidate_completing_profile_v2_about';
    AmplitudeHitOptionsEnum["CandidateCompletingProfileV2PersonalData"] = 'candidate_completing_profile_v2_personal_data';
    AmplitudeHitOptionsEnum["CandidateDashboardAccess"] = 'candidate_dashboard_access';
    AmplitudeHitOptionsEnum["CandidateClickPageBlog"] = 'candidate_click_page_blog';
    AmplitudeHitOptionsEnum["CandidateClickPageSimilarJobs"] = 'candidate_click_page_similar_jobs';
    AmplitudeHitOptionsEnum["CandidateClickPageCreateProfile"] = 'candidate_click_page_create_profile';
    AmplitudeHitOptionsEnum["CandidateShareJobOnLinkedin"] = 'candidate_share_job_on_linkedin';
    AmplitudeHitOptionsEnum["CandidateShareJobOnWhatsapp"] = 'candidate_share_job_on_whatsapp';
    AmplitudeHitOptionsEnum["CandidateShareJobOnTwitter"] = 'candidate_share_job_on_twitter';
    AmplitudeHitOptionsEnum["CandidateShowedInterest"] = 'candidate_showed_interest';
    AmplitudeHitOptionsEnum["CompanyScheduledDemonstration"] = 'company_scheduled_demonstration';
    AmplitudeHitOptionsEnum["CompanyCandidatesFilterClickCandidate"] = 'company_candidates_filter_click_candidate';
    AmplitudeHitOptionsEnum["CompanyAccessBids"] = 'company_access_bids';
    AmplitudeHitOptionsEnum["CompanyDetailedBidAccess"] = 'company_detailed_bid_access';
    AmplitudeHitOptionsEnum["CompanyDetailedBidSent"] = 'company_detailed_bid_sent';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2Status"] = 'candidate_international_completing_profile_v2_status';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2Career"] = 'candidate_international_completing_profile_v2_career';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2Skills"] = 'candidate_international_completing_profile_v2_skills';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2Experiences"] = 'candidate_international_completing_profile_v2_experiences';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2About"] = 'candidate_international_completing_profile_v2_about';
    AmplitudeHitOptionsEnum["CandidateInternationalCompletingProfileV2PersonalData"] = 'candidate_international_completing_profile_v2_personal_data';
    AmplitudeHitOptionsEnum["CandidateSignup"] = 'candidate_signup';
    AmplitudeHitOptionsEnum["CandidateBecameAproved"] = 'candidate_became_aproved';
    AmplitudeHitOptionsEnum["CandidateInternationalSignup"] = 'candidate_international_signup';
    AmplitudeHitOptionsEnum["CandidateInternationalBecameAproved"] = 'candidate_international_became_aproved';
    AmplitudeHitOptionsEnum["CandidateInternationalWaitingEnglishValidation"] = 'candidate_international_waiting_english_validation';
    AmplitudeHitOptionsEnum["CandidateIntentToPassEnglishAssessment"] = 'candidate_intent_to_pass_english_assessment';
    AmplitudeHitOptionsEnum["XavierApprovedCandidate"] = 'xavier_approved_candidate';
    AmplitudeHitOptionsEnum["CandidateUpdateProfile"] = 'candidate_update_profile';
    AmplitudeHitOptionsEnum["CompanyRequestHubAccessSalaryPage"] = 'company_request_hub_access_salary_page';
    AmplitudeHitOptionsEnum["CompanyAccessHubPositionsPage"] = 'company_access_hub_positions_page';
    AmplitudeHitOptionsEnum["CompanyAccessHubSalaryPage"] = 'company_access_hub_salary_page';
})(AmplitudeHitOptionsEnum || (AmplitudeHitOptionsEnum = {}));
var AmplitudeUserTypeEnum;
(function(AmplitudeUserTypeEnum) {
    AmplitudeUserTypeEnum["Company"] = 'company';
    AmplitudeUserTypeEnum["Candidate"] = 'candidate';
})(AmplitudeUserTypeEnum || (AmplitudeUserTypeEnum = {}));
var AssessmentLevelEnum;
(function(AssessmentLevelEnum) {
    AssessmentLevelEnum["Beginner"] = 'beginner';
    AssessmentLevelEnum["Intermediate"] = 'intermediate';
    AssessmentLevelEnum["Advanced"] = 'advanced';
    AssessmentLevelEnum["Fluent"] = 'fluent';
})(AssessmentLevelEnum || (AssessmentLevelEnum = {}));
var AvailableFeedbackEnum;
(function(AvailableFeedbackEnum) {
    AvailableFeedbackEnum[/** Não quero mudar de emprego neste momento. */ "DontWantChangeJob"] = 'dont_want_change_job';
    AvailableFeedbackEnum[/** Encontrei uma oportunidade dentro da GeekHunter. */ "JobFoundOnGeek"] = 'job_found_on_geek';
    AvailableFeedbackEnum[/** Encontrei uma oportunidade fora da GeekHunter. */ "JobFoundOffGeek"] = 'job_found_off_geek';
    AvailableFeedbackEnum[/** A GeekHunter não atendeu as minhas expectativas. */ "GeekhunterNotMetExpectations"] = 'geekhunter_not_met_expectations';
    AvailableFeedbackEnum[/** Estou participando de outros processos através da GeekHunter e gostaria de focar neles. */ "FocusedOnOtherProcesses"] = 'focused_on_other_processes';
    AvailableFeedbackEnum[/** Outro */ "Others"] = 'others';
})(AvailableFeedbackEnum || (AvailableFeedbackEnum = {}));
var BidOriginEnum;
(function(BidOriginEnum) {
    BidOriginEnum["DirectCandidateProfile"] = 'direct_candidate_profile';
    BidOriginEnum["MatchSimilarity"] = 'match_similarity';
    BidOriginEnum["SearchCandidate"] = 'search_candidate';
    BidOriginEnum["FavoriteCandidate"] = 'favorite_candidate';
    BidOriginEnum["BlockedCandidate"] = 'blocked_candidate';
    BidOriginEnum["GeekflowRecommendationJorel"] = 'geekflow_recommendation_jorel';
    BidOriginEnum["GeekflowRecommendationCs"] = 'geekflow_recommendation_cs';
    BidOriginEnum["GeekflowRecommendationInterest"] = 'geekflow_recommendation_interest';
    BidOriginEnum["GeekflowCandidateActive"] = 'geekflow_candidate_active';
    BidOriginEnum["GeekflowArchivedCompany"] = 'geekflow_archived_company';
    BidOriginEnum["GeekflowArchivedCandidate"] = 'geekflow_archived_candidate';
    BidOriginEnum["CanditeQuitBidInviteAgain"] = 'candite_quit_bid_invite_again';
    BidOriginEnum["CanditeQuitBidCandidateProfile"] = 'candite_quit_bid_candidate_profile';
    BidOriginEnum["DirectBidCreatePage"] = 'direct_bid_create_page';
    BidOriginEnum["MesseagesCandidateProfile"] = 'messeages_candidate_profile';
    BidOriginEnum["CsRecommendationLink"] = 'cs_recommendation_link';
    BidOriginEnum["GeekflowRecommendationSearch"] = 'geekflow_recommendation_search';
    BidOriginEnum["GeekflowCandidateInterest"] = 'geekflow_candidate_interest';
})(BidOriginEnum || (BidOriginEnum = {}));
var BidStatusEnum;
(function(BidStatusEnum) {
    BidStatusEnum[/** Pendente */ "Waiting"] = 'waiting';
    BidStatusEnum[/** Aceito */ "Accepted"] = 'accepted';
    BidStatusEnum[/** Recusado */ "Rejected"] = 'rejected';
})(BidStatusEnum || (BidStatusEnum = {}));
var CandidateInterestJobInterestTypeEnum;
(function(CandidateInterestJobInterestTypeEnum) {
    CandidateInterestJobInterestTypeEnum["Application"] = 'application';
    CandidateInterestJobInterestTypeEnum["Interest"] = 'interest';
})(CandidateInterestJobInterestTypeEnum || (CandidateInterestJobInterestTypeEnum = {}));
var CareerSlugEnum;
(function(CareerSlugEnum) {
    CareerSlugEnum["Data"] = 'data';
    CareerSlugEnum["Design"] = 'design';
    CareerSlugEnum["Product"] = 'product';
    CareerSlugEnum["QaTestingSupport"] = 'qa_testing_support';
    CareerSlugEnum["ItInfraSoftware"] = 'it_infra_software';
    CareerSlugEnum["Sales"] = 'sales';
    CareerSlugEnum["Cs"] = 'cs';
    CareerSlugEnum["Events"] = 'events';
    CareerSlugEnum["Marketing"] = 'marketing';
    CareerSlugEnum["Finance"] = 'finance';
    CareerSlugEnum["Hr"] = 'hr';
    CareerSlugEnum["StrategyInnovation"] = 'strategy_innovation';
    CareerSlugEnum["Operations"] = 'operations';
    CareerSlugEnum["LegalCompliance"] = 'legal_compliance';
    CareerSlugEnum["Projects"] = 'projects';
    CareerSlugEnum["Uncategorized"] = 'uncategorized';
})(CareerSlugEnum || (CareerSlugEnum = {}));
var CompanyCountryEnum;
(function(CompanyCountryEnum) {
    CompanyCountryEnum["Brazil"] = 'Brazil';
    CompanyCountryEnum["Usa"] = 'USA';
    CompanyCountryEnum["Canada"] = 'Canada';
    CompanyCountryEnum["China"] = 'China';
    CompanyCountryEnum["Netherlands"] = 'Netherlands';
    CompanyCountryEnum["England"] = 'England';
    CompanyCountryEnum["Estonia"] = 'Estonia';
    CompanyCountryEnum["Switzerland"] = 'Switzerland';
    CompanyCountryEnum["Portugal"] = 'Portugal';
})(CompanyCountryEnum || (CompanyCountryEnum = {}));
var CompanyDemoEnum;
(function(CompanyDemoEnum) {
    CompanyDemoEnum["NotScheduled"] = 'not_scheduled';
    CompanyDemoEnum["Scheduled"] = 'scheduled';
    CompanyDemoEnum["ScheduleLater"] = 'schedule_later';
    CompanyDemoEnum["ContactRequested"] = 'contact_requested';
})(CompanyDemoEnum || (CompanyDemoEnum = {}));
var CompanyLocationEnum;
(function(CompanyLocationEnum) {
    CompanyLocationEnum[/** us */ "Us"] = 'us';
    CompanyLocationEnum[/** brazil */ "Brazil"] = 'brazil';
})(CompanyLocationEnum || (CompanyLocationEnum = {}));
var CompanyPackageEnum;
(function(CompanyPackageEnum) {
    CompanyPackageEnum["Normal"] = 'normal';
    CompanyPackageEnum["Trigger"] = 'trigger';
    CompanyPackageEnum["Basic"] = 'basic';
    CompanyPackageEnum["Flex"] = 'flex';
    CompanyPackageEnum["NewFlex"] = 'new_flex';
})(CompanyPackageEnum || (CompanyPackageEnum = {}));
var CompanyPackageStatusEnum;
(function(CompanyPackageStatusEnum) {
    CompanyPackageStatusEnum["Canceled"] = 'canceled';
    CompanyPackageStatusEnum["Open"] = 'open';
    CompanyPackageStatusEnum["Done"] = 'done';
    CompanyPackageStatusEnum["Upsell"] = 'upsell';
    CompanyPackageStatusEnum["Paused"] = 'paused';
})(CompanyPackageStatusEnum || (CompanyPackageStatusEnum = {}));
var CompanyPlanUpgradeTriggerEnum;
(function(CompanyPlanUpgradeTriggerEnum) {
    CompanyPlanUpgradeTriggerEnum["ShowSalary"] = 'show_salary';
    CompanyPlanUpgradeTriggerEnum["ShowSocialNetworks"] = 'show_social_networks';
    CompanyPlanUpgradeTriggerEnum["ShowSearchStatus"] = 'show_search_status';
    CompanyPlanUpgradeTriggerEnum["ShowSelectedByIa"] = 'show_selected_by_ia';
    CompanyPlanUpgradeTriggerEnum["ShowEvaluatedByGeek"] = 'show_evaluated_by_geek';
    CompanyPlanUpgradeTriggerEnum["FilterBySalary"] = 'filter_by_salary';
    CompanyPlanUpgradeTriggerEnum["FilterByDiversity"] = 'filter_by_diversity';
    CompanyPlanUpgradeTriggerEnum["FilterBySearchStatus"] = 'filter_by_search_status';
    CompanyPlanUpgradeTriggerEnum["FilterByRecommended"] = 'filter_by_recommended';
    CompanyPlanUpgradeTriggerEnum["AddNewJobs"] = 'add_new_jobs';
    CompanyPlanUpgradeTriggerEnum["AddUsers"] = 'add_users';
    CompanyPlanUpgradeTriggerEnum["ShowMoreCandidates"] = 'show_more_candidates';
})(CompanyPlanUpgradeTriggerEnum || (CompanyPlanUpgradeTriggerEnum = {}));
var CompanySegmentationEnum;
(function(CompanySegmentationEnum) {
    CompanySegmentationEnum["G1"] = "G1";
    CompanySegmentationEnum["G2"] = "G2";
    CompanySegmentationEnum["G3"] = "G3";
    CompanySegmentationEnum["G4"] = "G4";
    CompanySegmentationEnum["G5"] = "G5";
    CompanySegmentationEnum["I1"] = "I1";
})(CompanySegmentationEnum || (CompanySegmentationEnum = {}));
var CompanyStatusEnum;
(function(CompanyStatusEnum) {
    CompanyStatusEnum["PendingApproval"] = 'pending_approval';
    CompanyStatusEnum["Accepted"] = 'accepted';
    CompanyStatusEnum["Rejected"] = 'rejected';
    CompanyStatusEnum["Lost"] = 'lost';
    CompanyStatusEnum["Limbo"] = 'limbo';
    CompanyStatusEnum["Blocked"] = 'blocked';
})(CompanyStatusEnum || (CompanyStatusEnum = {}));
var CompanyUserAccessHubEnum;
(function(CompanyUserAccessHubEnum) {
    CompanyUserAccessHubEnum["Limited"] = 'limited';
    CompanyUserAccessHubEnum["Full"] = 'full';
})(CompanyUserAccessHubEnum || (CompanyUserAccessHubEnum = {}));
var CompanyUserActivityLogEventTypeEnum;
(function(CompanyUserActivityLogEventTypeEnum) {
    CompanyUserActivityLogEventTypeEnum["RegistrationsIndex"] = 'registrations_index';
    CompanyUserActivityLogEventTypeEnum["RegistrationsShow"] = 'registrations_show';
    CompanyUserActivityLogEventTypeEnum["RegistrationsIndexNotAuthorized"] = 'registrations_index_not_authorized';
    CompanyUserActivityLogEventTypeEnum["RegistrationsShowNotAvailable"] = 'registrations_show_not_available';
    CompanyUserActivityLogEventTypeEnum["GeekFlowIndex"] = 'geek_flow_index';
    CompanyUserActivityLogEventTypeEnum["GeekFlowRecommendation"] = 'geek_flow_recommendation';
    CompanyUserActivityLogEventTypeEnum["GeekFlowCandidate"] = 'geek_flow_candidate';
    CompanyUserActivityLogEventTypeEnum["AcceptTermsOfService"] = 'accept_terms_of_service';
    CompanyUserActivityLogEventTypeEnum["UnsetJobHiddenCandidate"] = 'unset_job_hidden_candidate';
    CompanyUserActivityLogEventTypeEnum["GeneralContactShow"] = 'general_contact_show';
    CompanyUserActivityLogEventTypeEnum["LinkedinContactShow"] = 'linkedin_contact_show';
    CompanyUserActivityLogEventTypeEnum["GithubContactShow"] = 'github_contact_show';
    CompanyUserActivityLogEventTypeEnum["StackOverflowContactShow"] = 'stack_overflow_contact_show';
    CompanyUserActivityLogEventTypeEnum["PortfolioContactShow"] = 'portfolio_contact_show';
    CompanyUserActivityLogEventTypeEnum["PortfolioExtraContactShow"] = 'portfolio_extra_contact_show';
    CompanyUserActivityLogEventTypeEnum["WhatsappContactShow"] = 'whatsapp_contact_show';
    CompanyUserActivityLogEventTypeEnum["GeekFlowRemoveRecommendation"] = 'geek_flow_remove_recommendation';
    CompanyUserActivityLogEventTypeEnum["GeekFlowCreateRecommendation"] = 'geek_flow_create_recommendation';
    CompanyUserActivityLogEventTypeEnum["CandidateNoteShow"] = 'candidate_note_show';
    CompanyUserActivityLogEventTypeEnum["GeekFlowCandidateApplication"] = 'geek_flow_candidate_application';
    CompanyUserActivityLogEventTypeEnum["TrialUpgradeCta"] = 'trial_upgrade_cta';
    CompanyUserActivityLogEventTypeEnum["TrialUpgradeRequest"] = 'trial_upgrade_request';
    CompanyUserActivityLogEventTypeEnum["SearchPoolSelectedByIaUpgradeRequest"] = 'search_pool_selected_by_ia_upgrade_request';
    CompanyUserActivityLogEventTypeEnum["SearchPoolGeekhunterApprovedUpgradeRequest"] = 'search_pool_geekhunter_approved_upgrade_request';
    CompanyUserActivityLogEventTypeEnum["PlanUpgradeRequest"] = 'plan_upgrade_request';
    CompanyUserActivityLogEventTypeEnum["RegistrationsChatPage"] = 'registrations_chat_page';
    CompanyUserActivityLogEventTypeEnum["CompanyAccessHubPositionsPage"] = 'company_access_hub_positions_page';
    CompanyUserActivityLogEventTypeEnum["CompanyAccessHubSalaryPage"] = 'company_access_hub_salary_page';
})(CompanyUserActivityLogEventTypeEnum || (CompanyUserActivityLogEventTypeEnum = {}));
var CompanyUserLanguageEnum;
(function(CompanyUserLanguageEnum) {
    CompanyUserLanguageEnum["PtBr"] = 'pt_br';
    CompanyUserLanguageEnum["En"] = 'en';
})(CompanyUserLanguageEnum || (CompanyUserLanguageEnum = {}));
var CompanyUserRoleEnum;
(function(CompanyUserRoleEnum) {
    CompanyUserRoleEnum["Traas"] = 'traas';
    CompanyUserRoleEnum["Administrator"] = 'administrator';
    CompanyUserRoleEnum["Manager"] = 'manager';
    CompanyUserRoleEnum["Viewer"] = 'viewer';
})(CompanyUserRoleEnum || (CompanyUserRoleEnum = {}));
var EducationLevelEnum;
(function(EducationLevelEnum) {
    EducationLevelEnum["All"] = 'all';
    EducationLevelEnum["PostgraduateOrHigher"] = 'postgraduate_or_higher';
    EducationLevelEnum["CompleteDegree"] = 'complete_degree';
    EducationLevelEnum["IncompleteDegree"] = 'incomplete_degree';
    EducationLevelEnum["Technician"] = 'technician';
})(EducationLevelEnum || (EducationLevelEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum[/** Presencial */ "Presential"] = 'presential';
    EventTypeEnum[/** Remoto */ "Remote"] = 'remote';
})(EventTypeEnum || (EventTypeEnum = {}));
var ExperienceLevelEnum;
(function(ExperienceLevelEnum) {
    ExperienceLevelEnum["Assistance"] = 'ASSISTANCE';
    ExperienceLevelEnum["Internship"] = 'INTERNSHIP';
    ExperienceLevelEnum["EntryLevel"] = 'ENTRY_LEVEL';
    ExperienceLevelEnum["MidLevel"] = 'MID_LEVEL';
    ExperienceLevelEnum["SeniorLevel"] = 'SENIOR_LEVEL';
    ExperienceLevelEnum["Director"] = 'DIRECTOR';
    ExperienceLevelEnum["Executive"] = 'EXECUTIVE';
    ExperienceLevelEnum["NotApplicable"] = 'NOT_APPLICABLE';
})(ExperienceLevelEnum || (ExperienceLevelEnum = {}));
var FeatureFlagsEnum;
(function(FeatureFlagsEnum) {
    FeatureFlagsEnum["SearchPoolSelectedByIa"] = 'search_pool_selected_by_ia';
    FeatureFlagsEnum["SearchPoolGeekhunterApproved"] = 'search_pool_geekhunter_approved';
})(FeatureFlagsEnum || (FeatureFlagsEnum = {}));
var GenderEnum;
(function(GenderEnum) {
    GenderEnum["Feminine"] = 'feminine';
    GenderEnum["Masculine"] = 'masculine';
    GenderEnum["Other"] = 'other';
    GenderEnum["NonBinary"] = 'non_binary';
    GenderEnum["PreferNotAnswer"] = 'prefer_not_answer';
})(GenderEnum || (GenderEnum = {}));
var HiringEnumTypes;
(function(HiringEnumTypes) {
    HiringEnumTypes["Pending"] = 'pending';
    HiringEnumTypes["Hired"] = 'hired';
    HiringEnumTypes["InReplacement"] = 'in_replacement';
    HiringEnumTypes["Replaced"] = 'replaced';
    HiringEnumTypes["Refused"] = 'refused';
    HiringEnumTypes["Mistake"] = 'mistake';
})(HiringEnumTypes || (HiringEnumTypes = {}));
var HiringOptionEnum;
(function(HiringOptionEnum) {
    HiringOptionEnum["National"] = 'national';
    HiringOptionEnum["International"] = 'international';
    HiringOptionEnum["Both"] = 'both';
})(HiringOptionEnum || (HiringOptionEnum = {}));
var JobTypeEnum;
(function(JobTypeEnum) {
    JobTypeEnum["FullSupport"] = 'full_support';
    JobTypeEnum["FullSupportWithApplication"] = 'full_support_with_application';
    JobTypeEnum["Ats"] = 'ats';
})(JobTypeEnum || (JobTypeEnum = {}));
var NoteTypeEnum;
(function(NoteTypeEnum) {
    NoteTypeEnum["CompanyUserNoteAboutCandidate"] = 'company_user_note_about_candidate';
})(NoteTypeEnum || (NoteTypeEnum = {}));
var OrderEnum;
(function(OrderEnum) {
    OrderEnum[/** Mais Recentes */ "Newer"] = 'newer';
    OrderEnum[/** Mais Antigos */ "Older"] = 'older';
    OrderEnum[/** Menor Remuneração */ "MinSalary"] = 'min_salary';
    OrderEnum[/** Maior Remuneração */ "MaxSalary"] = 'max_salary';
})(OrderEnum || (OrderEnum = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["CreditCard"] = 'credit_card';
    PaymentMethod["BankSlip"] = 'bank_slip';
})(PaymentMethod || (PaymentMethod = {}));
var PeriodEnum;
(function(PeriodEnum) {
    PeriodEnum["Monthly"] = 'monthly';
    PeriodEnum["Annually"] = 'annually';
})(PeriodEnum || (PeriodEnum = {}));
var RegistrationFlowEnum;
(function(RegistrationFlowEnum) {
    RegistrationFlowEnum["RegistrationFlowV1"] = 'registration_flow_v1';
    RegistrationFlowEnum["RegistrationFlowV2"] = 'registration_flow_v2';
    RegistrationFlowEnum["LmFlowV1"] = 'lm_flow_v1';
    RegistrationFlowEnum["LmFlowV2"] = 'lm_flow_v2';
    RegistrationFlowEnum["BackofficeOutboundV1"] = 'backoffice_outbound_v1';
    RegistrationFlowEnum["CheckoutV1"] = 'checkout_v1';
    RegistrationFlowEnum["CheckoutV2"] = 'checkout_v2';
})(RegistrationFlowEnum || (RegistrationFlowEnum = {}));
var ScheduleTypeEnum;
(function(ScheduleTypeEnum) {
    ScheduleTypeEnum["NotScheduled"] = 'not_scheduled';
    ScheduleTypeEnum["Scheduled"] = 'scheduled';
    ScheduleTypeEnum["ScheduleLater"] = 'schedule_later';
    ScheduleTypeEnum["ContactRequested"] = 'contact_requested';
})(ScheduleTypeEnum || (ScheduleTypeEnum = {}));
var SearchPoolFilterEnum;
(function(SearchPoolFilterEnum) {
    SearchPoolFilterEnum["All"] = 'all';
    SearchPoolFilterEnum["SelectedByIa"] = 'selected_by_ia';
    SearchPoolFilterEnum["GeekhunterApproved"] = 'geekhunter_approved';
})(SearchPoolFilterEnum || (SearchPoolFilterEnum = {}));
var SearchStatusEnum;
(function(SearchStatusEnum) {
    SearchStatusEnum[/** Não estou aberto a oportunidades no momento. */ "NotOpenForOpportunities"] = 'not_open_for_opportunities';
    SearchStatusEnum[/** Busco oportunidades para iniciar o trabalho imediatamente. */ "SearchingForAJobRightNow"] = 'searching_for_a_job_right_now';
    SearchStatusEnum[/** Estou empregado, mas busco novos desafios. */ "HiredButSearchingNewThings"] = 'hired_but_searching_new_things';
    SearchStatusEnum[/** Não procuro emprego ativamente, mas estou aberto a avaliar novas oportunidades. */ "NotSearchingButCanHearAboutNewOpportunities"] = 'not_searching_but_can_hear_about_new_opportunities';
})(SearchStatusEnum || (SearchStatusEnum = {}));
var SearchStatusFilterEnum;
(function(SearchStatusFilterEnum) {
    SearchStatusFilterEnum["All"] = 'all';
    SearchStatusFilterEnum[/** Busco oportunidades para iniciar o trabalho imediatamente. */ "SearchingForAJobRightNow"] = 'searching_for_a_job_right_now';
    SearchStatusFilterEnum[/** Estou empregado, mas busco novos desafios. */ "HiredButSearchingNewThings"] = 'hired_but_searching_new_things';
    SearchStatusFilterEnum[/** Não procuro emprego ativamente, mas estou aberto a avaliar novas oportunidades. */ "NotSearchingButCanHearAboutNewOpportunities"] = 'not_searching_but_can_hear_about_new_opportunities';
})(SearchStatusFilterEnum || (SearchStatusFilterEnum = {}));
var SeniorityEnum;
(function(SeniorityEnum) {
    SeniorityEnum[/** Não aplicável */ "NotApplicable"] = 'NOT_APPLICABLE';
    SeniorityEnum[/** Assistente */ "Assistance"] = 'ASSISTANCE';
    SeniorityEnum[/** Estágio */ "Internship"] = 'INTERNSHIP';
    SeniorityEnum[/** Júnior */ "EntryLevel"] = 'ENTRY_LEVEL';
    SeniorityEnum[/** Pleno */ "MidLevel"] = 'MID_LEVEL';
    SeniorityEnum[/** Sênior */ "SeniorLevel"] = 'SENIOR_LEVEL';
    SeniorityEnum[/** Diretor */ "Director"] = 'DIRECTOR';
    SeniorityEnum[/** Executivo */ "Executive"] = 'EXECUTIVE';
})(SeniorityEnum || (SeniorityEnum = {}));
var SituationEnum;
(function(SituationEnum) {
    SituationEnum["Registered"] = 'registered';
    SituationEnum["RegisterComplete"] = 'register_complete';
    SituationEnum["WaitingApproval"] = 'waiting_approval';
    SituationEnum["Approved"] = 'approved';
    SituationEnum["Suspended"] = 'suspended';
    SituationEnum["Disabled"] = 'disabled';
    SituationEnum["Hired"] = 'hired';
    SituationEnum["Locked"] = 'locked';
    SituationEnum["IncompatibleProfile"] = 'incompatible_profile';
    SituationEnum["ReevaluationRequired"] = 'reevaluation_required';
    SituationEnum["WaitingApprovalReevaluation"] = 'waiting_approval_reevaluation';
    SituationEnum["EarlyStageCareer"] = 'early_stage_career';
    SituationEnum["ProfileNeedImprovement"] = 'profile_need_improvement';
    SituationEnum["Excluded"] = 'excluded';
    SituationEnum["CandidateAppliedOnly"] = 'candidate_applied_only';
})(SituationEnum || (SituationEnum = {}));
var SpecialNecessityEnum;
(function(SpecialNecessityEnum) {
    SpecialNecessityEnum["None"] = 'none';
    SpecialNecessityEnum["Physical"] = 'physical';
    SpecialNecessityEnum["Mental"] = 'mental';
    SpecialNecessityEnum["Hearing"] = 'hearing';
    SpecialNecessityEnum["Visual"] = 'visual';
    SpecialNecessityEnum["Intellectual"] = 'intellectual';
    SpecialNecessityEnum["Other"] = 'other';
})(SpecialNecessityEnum || (SpecialNecessityEnum = {}));
var SupportedProcessor;
(function(SupportedProcessor) {
    SupportedProcessor["Diners"] = 'diners';
    SupportedProcessor["Amex"] = 'amex';
    SupportedProcessor["Mastercard"] = 'mastercard';
    SupportedProcessor["Visa"] = 'visa';
})(SupportedProcessor || (SupportedProcessor = {}));
var TeamMemberRoleTypeEnum;
(function(TeamMemberRoleTypeEnum) {
    TeamMemberRoleTypeEnum["Farmer"] = 'farmer';
    TeamMemberRoleTypeEnum["Hunter"] = 'hunter';
    TeamMemberRoleTypeEnum["Manager"] = 'manager';
    TeamMemberRoleTypeEnum["FarmerUnit"] = 'farmer_unit';
    TeamMemberRoleTypeEnum["FarmerPackage"] = 'farmer_package';
    TeamMemberRoleTypeEnum["CsOnboarding"] = 'cs_onboarding';
    TeamMemberRoleTypeEnum["UnlimitedPackagesLeader"] = 'unlimited_packages_leader';
    TeamMemberRoleTypeEnum["PlansLeader"] = 'plans_leader';
    TeamMemberRoleTypeEnum["Other"] = 'other';
})(TeamMemberRoleTypeEnum || (TeamMemberRoleTypeEnum = {}));
var TechnologySubtypeEnum;
(function(TechnologySubtypeEnum) {
    TechnologySubtypeEnum["Language"] = 'language';
    TechnologySubtypeEnum["Framework"] = 'framework';
    TechnologySubtypeEnum["Knowledge"] = 'knowledge';
})(TechnologySubtypeEnum || (TechnologySubtypeEnum = {}));
var TierEnum;
(function(TierEnum) {
    TierEnum["Hub"] = 'hub';
    TierEnum["Lite"] = 'lite';
    TierEnum["Standard"] = 'standard';
    TierEnum["Recruiter"] = 'recruiter';
    TierEnum["LiteV2"] = 'lite_v2';
    TierEnum["StandardV2"] = 'standard_v2';
    TierEnum["Premium"] = 'premium';
    TierEnum["HubPremium"] = 'hub_premium';
    TierEnum["Old"] = 'old';
})(TierEnum || (TierEnum = {}));
var WorkModeEnum;
(function(WorkModeEnum) {
    WorkModeEnum[/** CLT */ "Clt"] = 'CLT';
    WorkModeEnum[/** PJ ou Cooperativa */ "Pj"] = 'PJ';
})(WorkModeEnum || (WorkModeEnum = {}));
var WorkRemoteEnum;
(function(WorkRemoteEnum) {
    WorkRemoteEnum[/** Não aceita trabalho remoto. */ "RemoteNo"] = 'remote_no';
    WorkRemoteEnum[/** Aceita trabalho remoto. */ "RemoteYes"] = 'remote_yes';
    WorkRemoteEnum[/** Aceita somente trabalho remoto. */ "RemoteOnly"] = 'remote_only';
})(WorkRemoteEnum || (WorkRemoteEnum = {}));
var RegisterAmplitudeHitDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject());
/**
 * __useRegisterAmplitudeHitMutation__
 *
 * To run a mutation, you first call `useRegisterAmplitudeHitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAmplitudeHitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAmplitudeHitMutation, { data, loading, error }] = useRegisterAmplitudeHitMutation({
 *   variables: {
 *      amplitudeHitType: // value for 'amplitudeHitType'
 *      userEmail: // value for 'userEmail'
 *      userType: // value for 'userType'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */ function useRegisterAmplitudeHitMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(RegisterAmplitudeHitDocument, options);
}
var RegisterAmplitudeHitAuthenticatedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject1());
/**
 * __useRegisterAmplitudeHitAuthenticatedMutation__
 *
 * To run a mutation, you first call `useRegisterAmplitudeHitAuthenticatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAmplitudeHitAuthenticatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAmplitudeHitAuthenticatedMutation, { data, loading, error }] = useRegisterAmplitudeHitAuthenticatedMutation({
 *   variables: {
 *      amplitudeHitType: // value for 'amplitudeHitType'
 *   },
 * });
 */ function useRegisterAmplitudeHitAuthenticatedMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(RegisterAmplitudeHitAuthenticatedDocument, options);
}
var CandidateRegisterStepAboutDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject2());
/**
 * __useCandidateRegisterStepAboutMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepAboutMutation, { data, loading, error }] = useCandidateRegisterStepAboutMutation({
 *   variables: {
 *      positionTitle: // value for 'positionTitle'
 *      summary: // value for 'summary'
 *      excludedCompaniesAttributes: // value for 'excludedCompaniesAttributes'
 *   },
 * });
 */ function useCandidateRegisterStepAboutMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepAboutDocument, options);
}
var CandidateRegisterStepCareerDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject3());
/**
 * __useCandidateRegisterStepCareerMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepCareerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepCareerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepCareerMutation, { data, loading, error }] = useCandidateRegisterStepCareerMutation({
 *   variables: {
 *      workRemote: // value for 'workRemote'
 *      pjSalary: // value for 'pjSalary'
 *      cltSalary: // value for 'cltSalary'
 *      usdSalary: // value for 'usdSalary'
 *      candidateCitiesAttributes: // value for 'candidateCitiesAttributes'
 *   },
 * });
 */ function useCandidateRegisterStepCareerMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepCareerDocument, options);
}
var CandidateRegisterStepExperiencesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject4());
/**
 * __useCandidateRegisterStepExperiencesMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepExperiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepExperiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepExperiencesMutation, { data, loading, error }] = useCandidateRegisterStepExperiencesMutation({
 *   variables: {
 *      noExperiences: // value for 'noExperiences'
 *      experiencesAttributes: // value for 'experiencesAttributes'
 *      educationsAttributes: // value for 'educationsAttributes'
 *      certificationsAttributes: // value for 'certificationsAttributes'
 *      projectsAttributes: // value for 'projectsAttributes'
 *   },
 * });
 */ function useCandidateRegisterStepExperiencesMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepExperiencesDocument, options);
}
var CandidateRegisterStepImageDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject5());
/**
 * __useCandidateRegisterStepImageMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepImageMutation, { data, loading, error }] = useCandidateRegisterStepImageMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useCandidateRegisterStepImageMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepImageDocument, options);
}
var CandidateRegisterStepLinkedinDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject6());
/**
 * __useCandidateRegisterStepLinkedinMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepLinkedinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepLinkedinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepLinkedinMutation, { data, loading, error }] = useCandidateRegisterStepLinkedinMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useCandidateRegisterStepLinkedinMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepLinkedinDocument, options);
}
var CandidateRegisterStepProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject7());
/**
 * __useCandidateRegisterStepProfileMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepProfileMutation, { data, loading, error }] = useCandidateRegisterStepProfileMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useCandidateRegisterStepProfileMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepProfileDocument, options);
}
var CandidateRegisterStepSkillsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject8());
/**
 * __useCandidateRegisterStepSkillsMutation__
 *
 * To run a mutation, you first call `useCandidateRegisterStepSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateRegisterStepSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateRegisterStepSkillsMutation, { data, loading, error }] = useCandidateRegisterStepSkillsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useCandidateRegisterStepSkillsMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CandidateRegisterStepSkillsDocument, options);
}
var UpdateCandidateDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject9());
/**
 * __useUpdateCandidateMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateMutation, { data, loading, error }] = useUpdateCandidateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */ function useUpdateCandidateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(UpdateCandidateDocument, options);
}
var CreateCurrentCandidateActivityLogDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject10());
/**
 * __useCreateCurrentCandidateActivityLogMutation__
 *
 * To run a mutation, you first call `useCreateCurrentCandidateActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrentCandidateActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrentCandidateActivityLogMutation, { data, loading, error }] = useCreateCurrentCandidateActivityLogMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */ function useCreateCurrentCandidateActivityLogMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateCurrentCandidateActivityLogDocument, options);
}
var CreateCurrentCandidateAvailableFeedbackDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject11());
/**
 * __useCreateCurrentCandidateAvailableFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateCurrentCandidateAvailableFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrentCandidateAvailableFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrentCandidateAvailableFeedbackMutation, { data, loading, error }] = useCreateCurrentCandidateAvailableFeedbackMutation({
 *   variables: {
 *      available: // value for 'available'
 *      feedbackType: // value for 'feedbackType'
 *      message: // value for 'message'
 *   },
 * });
 */ function useCreateCurrentCandidateAvailableFeedbackMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateCurrentCandidateAvailableFeedbackDocument, options);
}
var RegisterCandidateFirstStepDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject12());
/**
 * __useRegisterCandidateFirstStepMutation__
 *
 * To run a mutation, you first call `useRegisterCandidateFirstStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCandidateFirstStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCandidateFirstStepMutation, { data, loading, error }] = useRegisterCandidateFirstStepMutation({
 *   variables: {
 *      termsOfService: // value for 'termsOfService'
 *      email: // value for 'email'
 *      emailNotification: // value for 'emailNotification'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      firstReferer: // value for 'firstReferer'
 *      fromReferral: // value for 'fromReferral'
 *      utmSource: // value for 'utmSource'
 *      utmMedium: // value for 'utmMedium'
 *      utmCampaign: // value for 'utmCampaign'
 *      utmTerm: // value for 'utmTerm'
 *      deviceType: // value for 'deviceType'
 *      lastRenderedSlug: // value for 'lastRenderedSlug'
 *   },
 * });
 */ function useRegisterCandidateFirstStepMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(RegisterCandidateFirstStepDocument, options);
}
var SetCurrentCandidateDashboardFirstAccessDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject13());
/**
 * __useSetCurrentCandidateDashboardFirstAccessMutation__
 *
 * To run a mutation, you first call `useSetCurrentCandidateDashboardFirstAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrentCandidateDashboardFirstAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrentCandidateDashboardFirstAccessMutation, { data, loading, error }] = useSetCurrentCandidateDashboardFirstAccessMutation({
 *   variables: {
 *      isDashboardFirstAccess: // value for 'isDashboardFirstAccess'
 *   },
 * });
 */ function useSetCurrentCandidateDashboardFirstAccessMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(SetCurrentCandidateDashboardFirstAccessDocument, options);
}
var SetCurrentCandidateStatusDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject14());
/**
 * __useSetCurrentCandidateStatusMutation__
 *
 * To run a mutation, you first call `useSetCurrentCandidateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrentCandidateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrentCandidateStatusMutation, { data, loading, error }] = useSetCurrentCandidateStatusMutation({
 *   variables: {
 *      searchStatus: // value for 'searchStatus'
 *      available: // value for 'available'
 *   },
 * });
 */ function useSetCurrentCandidateStatusMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(SetCurrentCandidateStatusDocument, options);
}
var SetCurrentCandidateWhatsappNotificationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject15());
/**
 * __useSetCurrentCandidateWhatsappNotificationMutation__
 *
 * To run a mutation, you first call `useSetCurrentCandidateWhatsappNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrentCandidateWhatsappNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrentCandidateWhatsappNotificationMutation, { data, loading, error }] = useSetCurrentCandidateWhatsappNotificationMutation({
 *   variables: {
 *      allowWhatsappNotification: // value for 'allowWhatsappNotification'
 *   },
 * });
 */ function useSetCurrentCandidateWhatsappNotificationMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(SetCurrentCandidateWhatsappNotificationDocument, options);
}
var CreateProspectDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject16());
/**
 * __useCreateProspectMutation__
 *
 * To run a mutation, you first call `useCreateProspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProspectMutation, { data, loading, error }] = useCreateProspectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      countryId: // value for 'countryId'
 *      phone: // value for 'phone'
 *   },
 * });
 */ function useCreateProspectMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateProspectDocument, options);
}
var PurchasePlanDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject17());
/**
 * __usePurchasePlanMutation__
 *
 * To run a mutation, you first call `usePurchasePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchasePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchasePlanMutation, { data, loading, error }] = usePurchasePlanMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function usePurchasePlanMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(PurchasePlanDocument, options);
}
var AcceptCompanyUserTermsOfServiceDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject18());
/**
 * __useAcceptCompanyUserTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcceptCompanyUserTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompanyUserTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCompanyUserTermsOfServiceMutation, { data, loading, error }] = useAcceptCompanyUserTermsOfServiceMutation({
 *   variables: {
 *   },
 * });
 */ function useAcceptCompanyUserTermsOfServiceMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(AcceptCompanyUserTermsOfServiceDocument, options);
}
var CompanyCancelSubscriptionDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject19());
/**
 * __useCompanyCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCompanyCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyCancelSubscriptionMutation, { data, loading, error }] = useCompanyCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */ function useCompanyCancelSubscriptionMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CompanyCancelSubscriptionDocument, options);
}
var CompanyRequestUpgradeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject20());
/**
 * __useCompanyRequestUpgradeMutation__
 *
 * To run a mutation, you first call `useCompanyRequestUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyRequestUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyRequestUpgradeMutation, { data, loading, error }] = useCompanyRequestUpgradeMutation({
 *   variables: {
 *      searchPool: // value for 'searchPool'
 *      planUpgradeTrigger: // value for 'planUpgradeTrigger'
 *      targetTier: // value for 'targetTier'
 *   },
 * });
 */ function useCompanyRequestUpgradeMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CompanyRequestUpgradeDocument, options);
}
var CreateBidDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject21());
/**
 * __useCreateBidMutation__
 *
 * To run a mutation, you first call `useCreateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidMutation, { data, loading, error }] = useCreateBidMutation({
 *   variables: {
 *      bidInputParams: // value for 'bidInputParams'
 *   },
 * });
 */ function useCreateBidMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateBidDocument, options);
}
var CreateNoteDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject22());
/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      noteInputParams: // value for 'noteInputParams'
 *   },
 * });
 */ function useCreateNoteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateNoteDocument, options);
}
var CreateScreeningCandidateDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject23());
/**
 * __useCreateScreeningCandidateMutation__
 *
 * To run a mutation, you first call `useCreateScreeningCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScreeningCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScreeningCandidateMutation, { data, loading, error }] = useCreateScreeningCandidateMutation({
 *   variables: {
 *      inputScreeningCandidate: // value for 'inputScreeningCandidate'
 *   },
 * });
 */ function useCreateScreeningCandidateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateScreeningCandidateDocument, options);
}
var DisableTwoFactorAuthenticationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject24());
/**
 * __useDisableTwoFactorAuthenticationMutation__
 *
 * To run a mutation, you first call `useDisableTwoFactorAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTwoFactorAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTwoFactorAuthenticationMutation, { data, loading, error }] = useDisableTwoFactorAuthenticationMutation({
 *   variables: {
 *   },
 * });
 */ function useDisableTwoFactorAuthenticationMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(DisableTwoFactorAuthenticationDocument, options);
}
var EnableTwoFactorAuthenticationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject25());
/**
 * __useEnableTwoFactorAuthenticationMutation__
 *
 * To run a mutation, you first call `useEnableTwoFactorAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTwoFactorAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTwoFactorAuthenticationMutation, { data, loading, error }] = useEnableTwoFactorAuthenticationMutation({
 *   variables: {
 *   },
 * });
 */ function useEnableTwoFactorAuthenticationMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(EnableTwoFactorAuthenticationDocument, options);
}
var GenerateTwoFactorAuthenticationSecretDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject26());
/**
 * __useGenerateTwoFactorAuthenticationSecretMutation__
 *
 * To run a mutation, you first call `useGenerateTwoFactorAuthenticationSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTwoFactorAuthenticationSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTwoFactorAuthenticationSecretMutation, { data, loading, error }] = useGenerateTwoFactorAuthenticationSecretMutation({
 *   variables: {
 *   },
 * });
 */ function useGenerateTwoFactorAuthenticationSecretMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(GenerateTwoFactorAuthenticationSecretDocument, options);
}
var RejectCandidateInterestJobDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject27());
/**
 * __useRejectCandidateInterestJobMutation__
 *
 * To run a mutation, you first call `useRejectCandidateInterestJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCandidateInterestJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCandidateInterestJobMutation, { data, loading, error }] = useRejectCandidateInterestJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useRejectCandidateInterestJobMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(RejectCandidateInterestJobDocument, options);
}
var ScheduleDemonstrationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject28());
/**
 * __useScheduleDemonstrationMutation__
 *
 * To run a mutation, you first call `useScheduleDemonstrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDemonstrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDemonstrationMutation, { data, loading, error }] = useScheduleDemonstrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notifySales: // value for 'notifySales'
 *      preferredContactForm: // value for 'preferredContactForm'
 *      type: // value for 'type'
 *   },
 * });
 */ function useScheduleDemonstrationMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(ScheduleDemonstrationDocument, options);
}
var SendUserEmailConfirmationInstructionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject29());
/**
 * __useSendUserEmailConfirmationInstructionsMutation__
 *
 * To run a mutation, you first call `useSendUserEmailConfirmationInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUserEmailConfirmationInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUserEmailConfirmationInstructionsMutation, { data, loading, error }] = useSendUserEmailConfirmationInstructionsMutation({
 *   variables: {
 *   },
 * });
 */ function useSendUserEmailConfirmationInstructionsMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(SendUserEmailConfirmationInstructionsDocument, options);
}
var ToggleFavoriteCandidateDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject30());
/**
 * __useToggleFavoriteCandidateMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteCandidateMutation, { data, loading, error }] = useToggleFavoriteCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      companyUserId: // value for 'companyUserId'
 *   },
 * });
 */ function useToggleFavoriteCandidateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(ToggleFavoriteCandidateDocument, options);
}
var ToggleHiddenCandidateDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject31());
/**
 * __useToggleHiddenCandidateMutation__
 *
 * To run a mutation, you first call `useToggleHiddenCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleHiddenCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleHiddenCandidateMutation, { data, loading, error }] = useToggleHiddenCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      companyUserId: // value for 'companyUserId'
 *   },
 * });
 */ function useToggleHiddenCandidateMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(ToggleHiddenCandidateDocument, options);
}
var UpdateCompanyCandidateSearchResultClickedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject32());
/**
 * __useUpdateCompanyCandidateSearchResultClickedMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyCandidateSearchResultClickedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyCandidateSearchResultClickedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyCandidateSearchResultClickedMutation, { data, loading, error }] = useUpdateCompanyCandidateSearchResultClickedMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */ function useUpdateCompanyCandidateSearchResultClickedMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(UpdateCompanyCandidateSearchResultClickedDocument, options);
}
var UpdateNoteDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject33());
/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      noteUpdateParams: // value for 'noteUpdateParams'
 *   },
 * });
 */ function useUpdateNoteMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(UpdateNoteDocument, options);
}
var UpdatePartnerIntegrationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject34());
/**
 * __useUpdatePartnerIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerIntegrationMutation, { data, loading, error }] = useUpdatePartnerIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */ function useUpdatePartnerIntegrationMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(UpdatePartnerIntegrationDocument, options);
}
var CreateCompanyUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject35());
/**
 * __useCreateCompanyUserMutation__
 *
 * To run a mutation, you first call `useCreateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyUserMutation, { data, loading, error }] = useCreateCompanyUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useCreateCompanyUserMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateCompanyUserDocument, options);
}
var CreateCompanyUserActivityLogDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject36());
/**
 * __useCreateCompanyUserActivityLogMutation__
 *
 * To run a mutation, you first call `useCreateCompanyUserActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyUserActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyUserActivityLogMutation, { data, loading, error }] = useCreateCompanyUserActivityLogMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */ function useCreateCompanyUserActivityLogMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(CreateCompanyUserActivityLogDocument, options);
}
var SwitchCompanyUserLanguageDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject37());
/**
 * __useSwitchCompanyUserLanguageMutation__
 *
 * To run a mutation, you first call `useSwitchCompanyUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchCompanyUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchCompanyUserLanguageMutation, { data, loading, error }] = useSwitchCompanyUserLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */ function useSwitchCompanyUserLanguageMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(SwitchCompanyUserLanguageDocument, options);
}
var ToggleActiveDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject38());
/**
 * __useToggleActiveMutation__
 *
 * To run a mutation, you first call `useToggleActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleActiveMutation, { data, loading, error }] = useToggleActiveMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useToggleActiveMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(ToggleActiveDocument, options);
}
var UpdateCompanyUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject39());
/**
 * __useUpdateCompanyUserMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserMutation, { data, loading, error }] = useUpdateCompanyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */ function useUpdateCompanyUserMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(UpdateCompanyUserDocument, options);
}
var CreateCurrentCandidateInterestJobDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject40());
/**
 * __useCreateCurrentCandidateInterestJobMutation__
 *
 * To run a mutation, you first call `useCreateCurrentCandidateInterestJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrentCandidateInterestJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrentCandidateInterestJobMutation, { data, loading, error }] = useCreateCurrentCandidateInterestJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      interestType: // value for 'interestType'
 *   },
 * });
 */ function useCreateCurrentCandidateInterestJobMutation(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D(CreateCurrentCandidateInterestJobDocument, options);
}
var CheckCandidateIsRegisteredDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject41());
/**
 * __useCheckCandidateIsRegisteredQuery__
 *
 * To run a query within a React component, call `useCheckCandidateIsRegisteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckCandidateIsRegisteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckCandidateIsRegisteredQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */ function useCheckCandidateIsRegisteredQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(CheckCandidateIsRegisteredDocument, options);
}
function useCheckCandidateIsRegisteredLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckCandidateIsRegisteredDocument, options);
}
var GetCandidateProfileDataDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject42());
/**
 * __useGetCandidateProfileDataQuery__
 *
 * To run a query within a React component, call `useGetCandidateProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProfileDataQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCandidateProfileDataQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCandidateProfileDataDocument, options);
}
function useGetCandidateProfileDataLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCandidateProfileDataDocument, options);
}
var GetCurrentCandidateAvailableDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject43());
/**
 * __useGetCurrentCandidateAvailableQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateAvailableQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateAvailableQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCurrentCandidateAvailableDocument, options);
}
function useGetCurrentCandidateAvailableLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateAvailableDocument, options);
}
var GetCurrentCandidateBasicInfoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject44());
/**
 * __useGetCurrentCandidateBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateBasicInfoQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCurrentCandidateBasicInfoDocument, options);
}
function useGetCurrentCandidateBasicInfoLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateBasicInfoDocument, options);
}
var GetCurrentCandidateHiringDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject45());
/**
 * __useGetCurrentCandidateHiringQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateHiringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateHiringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateHiringQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateHiringQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidateHiringDocument, options);
}
function useGetCurrentCandidateHiringLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateHiringDocument, options);
}
var GetCurrentCandidateImageDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject46());
/**
 * __useGetCurrentCandidateImageQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateImageQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateImageQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidateImageDocument, options);
}
function useGetCurrentCandidateImageLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateImageDocument, options);
}
var GetCurrentCandidateInterestJobsByJobIdsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject47());
/**
 * __useGetCurrentCandidateInterestJobsByJobIdsQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateInterestJobsByJobIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateInterestJobsByJobIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateInterestJobsByJobIdsQuery({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */ function useGetCurrentCandidateInterestJobsByJobIdsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidateInterestJobsByJobIdsDocument, options);
}
function useGetCurrentCandidateInterestJobsByJobIdsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateInterestJobsByJobIdsDocument, options);
}
var GetCurrentCandidateMainInfoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject48());
/**
 * __useGetCurrentCandidateMainInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateMainInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateMainInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateMainInfoQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateMainInfoQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCurrentCandidateMainInfoDocument, options);
}
function useGetCurrentCandidateMainInfoLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateMainInfoDocument, options);
}
var GetCurrentCandidateMd5EmailDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject49());
/**
 * __useGetCurrentCandidateMd5EmailQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateMd5EmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateMd5EmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateMd5EmailQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateMd5EmailQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCurrentCandidateMd5EmailDocument, options);
}
function useGetCurrentCandidateMd5EmailLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateMd5EmailDocument, options);
}
var GetCurrentCandidatePendingBidsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject50());
/**
 * __useGetCurrentCandidatePendingBidsQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidatePendingBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidatePendingBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidatePendingBidsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidatePendingBidsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidatePendingBidsDocument, options);
}
function useGetCurrentCandidatePendingBidsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidatePendingBidsDocument, options);
}
var GetCurrentCandidatePendingInterviewsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject51());
/**
 * __useGetCurrentCandidatePendingInterviewsQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidatePendingInterviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidatePendingInterviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidatePendingInterviewsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidatePendingInterviewsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidatePendingInterviewsDocument, options);
}
function useGetCurrentCandidatePendingInterviewsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidatePendingInterviewsDocument, options);
}
var GetCurrentCandidateUnreadMessagesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject52());
/**
 * __useGetCurrentCandidateUnreadMessagesQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateUnreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateUnreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateUnreadMessagesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateUnreadMessagesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidateUnreadMessagesDocument, options);
}
function useGetCurrentCandidateUnreadMessagesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateUnreadMessagesDocument, options);
}
var GetCurrentCandidateWhatsAppNotificationStatusDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject53());
/**
 * __useGetCurrentCandidateWhatsAppNotificationStatusQuery__
 *
 * To run a query within a React component, call `useGetCurrentCandidateWhatsAppNotificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCandidateWhatsAppNotificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCandidateWhatsAppNotificationStatusQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCandidateWhatsAppNotificationStatusQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCandidateWhatsAppNotificationStatusDocument, options);
}
function useGetCurrentCandidateWhatsAppNotificationStatusLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCandidateWhatsAppNotificationStatusDocument, options);
}
var GetFocusSuggestionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject54());
/**
 * __useGetFocusSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetFocusSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFocusSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFocusSuggestionsQuery({
 *   variables: {
 *      careerSlug: // value for 'careerSlug'
 *      onlyActiveJobs: // value for 'onlyActiveJobs'
 *   },
 * });
 */ function useGetFocusSuggestionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetFocusSuggestionsDocument, options);
}
function useGetFocusSuggestionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFocusSuggestionsDocument, options);
}
var GetRegisterSuggestionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject55());
/**
 * __useGetRegisterSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetRegisterSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisterSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisterSuggestionsQuery({
 *   variables: {
 *      careerSlug: // value for 'careerSlug'
 *   },
 * });
 */ function useGetRegisterSuggestionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetRegisterSuggestionsDocument, options);
}
function useGetRegisterSuggestionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetRegisterSuggestionsDocument, options);
}
var ImportLinkedinProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject56());
/**
 * __useImportLinkedinProfileQuery__
 *
 * To run a query within a React component, call `useImportLinkedinProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportLinkedinProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportLinkedinProfileQuery({
 *   variables: {
 *      linkedinProfileUrl: // value for 'linkedinProfileUrl'
 *   },
 * });
 */ function useImportLinkedinProfileQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(ImportLinkedinProfileDocument, options);
}
function useImportLinkedinProfileLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ImportLinkedinProfileDocument, options);
}
var ListCareersDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject57());
/**
 * __useListCareersQuery__
 *
 * To run a query within a React component, call `useListCareersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCareersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCareersQuery({
 *   variables: {
 *   },
 * });
 */ function useListCareersQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(ListCareersDocument, options);
}
function useListCareersLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListCareersDocument, options);
}
var ShowCandidateProfileDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject58());
/**
 * __useShowCandidateProfileQuery__
 *
 * To run a query within a React component, call `useShowCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowCandidateProfileQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */ function useShowCandidateProfileQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ShowCandidateProfileDocument, options);
}
function useShowCandidateProfileLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ShowCandidateProfileDocument, options);
}
var CheckPasswordDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject59());
/**
 * __useCheckPasswordQuery__
 *
 * To run a query within a React component, call `useCheckPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPasswordQuery({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */ function useCheckPasswordQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(CheckPasswordDocument, options);
}
function useCheckPasswordLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckPasswordDocument, options);
}
var CheckTwoFactorAuthenticationCodeDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject60());
/**
 * __useCheckTwoFactorAuthenticationCodeQuery__
 *
 * To run a query within a React component, call `useCheckTwoFactorAuthenticationCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckTwoFactorAuthenticationCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckTwoFactorAuthenticationCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */ function useCheckTwoFactorAuthenticationCodeQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(CheckTwoFactorAuthenticationCodeDocument, options);
}
function useCheckTwoFactorAuthenticationCodeLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CheckTwoFactorAuthenticationCodeDocument, options);
}
var GetAccountManagerInfoForHeaderDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject61());
/**
 * __useGetAccountManagerInfoForHeaderQuery__
 *
 * To run a query within a React component, call `useGetAccountManagerInfoForHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountManagerInfoForHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountManagerInfoForHeaderQuery({
 *   variables: {
 *   },
 * });
 */ function useGetAccountManagerInfoForHeaderQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetAccountManagerInfoForHeaderDocument, options);
}
function useGetAccountManagerInfoForHeaderLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetAccountManagerInfoForHeaderDocument, options);
}
var GetActiveFocusesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject62());
/**
 * __useGetActiveFocusesQuery__
 *
 * To run a query within a React component, call `useGetActiveFocusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveFocusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveFocusesQuery({
 *   variables: {
 *      careerSlugs: // value for 'careerSlugs'
 *      availableForCandidateSearch: // value for 'availableForCandidateSearch'
 *      availableForCandidates: // value for 'availableForCandidates'
 *   },
 * });
 */ function useGetActiveFocusesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetActiveFocusesDocument, options);
}
function useGetActiveFocusesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetActiveFocusesDocument, options);
}
var GetCandidateFilterOptionsByIdDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject63());
/**
 * __useGetCandidateFilterOptionsByIdQuery__
 *
 * To run a query within a React component, call `useGetCandidateFilterOptionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateFilterOptionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateFilterOptionsByIdQuery({
 *   variables: {
 *      cityIds: // value for 'cityIds'
 *      techIds: // value for 'techIds'
 *      shouldGetCities: // value for 'shouldGetCities'
 *      shouldGetTechs: // value for 'shouldGetTechs'
 *   },
 * });
 */ function useGetCandidateFilterOptionsByIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCandidateFilterOptionsByIdDocument, options);
}
function useGetCandidateFilterOptionsByIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCandidateFilterOptionsByIdDocument, options);
}
var GetCandidateFilterSelectOptionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject64());
/**
 * __useGetCandidateFilterSelectOptionsQuery__
 *
 * To run a query within a React component, call `useGetCandidateFilterSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateFilterSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateFilterSelectOptionsQuery({
 *   variables: {
 *      careerSlugs: // value for 'careerSlugs'
 *      availableForCandidateSearch: // value for 'availableForCandidateSearch'
 *   },
 * });
 */ function useGetCandidateFilterSelectOptionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCandidateFilterSelectOptionsDocument, options);
}
function useGetCandidateFilterSelectOptionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCandidateFilterSelectOptionsDocument, options);
}
var GetCitiesSuggestionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject65());
/**
 * __useGetCitiesSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetCitiesSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCitiesSuggestionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCitiesSuggestionsDocument, options);
}
function useGetCitiesSuggestionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCitiesSuggestionsDocument, options);
}
var GetCityByIdsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject66());
/**
 * __useGetCityByIdsQuery__
 *
 * To run a query within a React component, call `useGetCityByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */ function useGetCityByIdsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCityByIdsDocument, options);
}
function useGetCityByIdsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCityByIdsDocument, options);
}
var GetCompanyAccountInfoForHeaderDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject67());
/**
 * __useGetCompanyAccountInfoForHeaderQuery__
 *
 * To run a query within a React component, call `useGetCompanyAccountInfoForHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAccountInfoForHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAccountInfoForHeaderQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCompanyAccountInfoForHeaderQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCompanyAccountInfoForHeaderDocument, options);
}
function useGetCompanyAccountInfoForHeaderLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCompanyAccountInfoForHeaderDocument, options);
}
var GetCompanyUserScheduleInfoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject68());
/**
 * __useGetCompanyUserScheduleInfoQuery__
 *
 * To run a query within a React component, call `useGetCompanyUserScheduleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUserScheduleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUserScheduleInfoQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCompanyUserScheduleInfoQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCompanyUserScheduleInfoDocument, options);
}
function useGetCompanyUserScheduleInfoLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCompanyUserScheduleInfoDocument, options);
}
var GetCurrentActiveJobsSearchCandidatesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject69());
/**
 * __useGetCurrentActiveJobsSearchCandidatesQuery__
 *
 * To run a query within a React component, call `useGetCurrentActiveJobsSearchCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentActiveJobsSearchCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentActiveJobsSearchCandidatesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentActiveJobsSearchCandidatesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentActiveJobsSearchCandidatesDocument, options);
}
function useGetCurrentActiveJobsSearchCandidatesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentActiveJobsSearchCandidatesDocument, options);
}
var GetCurrentCompanyUserDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject70());
/**
 * __useGetCurrentCompanyUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyUserQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCompanyUserQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCompanyUserDocument, options);
}
function useGetCurrentCompanyUserLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCompanyUserDocument, options);
}
var GetCurrentCompanyUserBasicInfoDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject71());
/**
 * __useGetCurrentCompanyUserBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyUserBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyUserBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyUserBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCompanyUserBasicInfoQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCompanyUserBasicInfoDocument, options);
}
function useGetCurrentCompanyUserBasicInfoLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCompanyUserBasicInfoDocument, options);
}
var GetCurrentCompanyUserCompanyCitiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject72());
/**
 * __useGetCurrentCompanyUserCompanyCitiesQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyUserCompanyCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyUserCompanyCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyUserCompanyCitiesQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCompanyUserCompanyCitiesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetCurrentCompanyUserCompanyCitiesDocument, options);
}
function useGetCurrentCompanyUserCompanyCitiesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCompanyUserCompanyCitiesDocument, options);
}
var GetCurrentCompanyUserIsConfirmedDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject73());
/**
 * __useGetCurrentCompanyUserIsConfirmedQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyUserIsConfirmedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyUserIsConfirmedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyUserIsConfirmedQuery({
 *   variables: {
 *   },
 * });
 */ function useGetCurrentCompanyUserIsConfirmedQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCurrentCompanyUserIsConfirmedDocument, options);
}
function useGetCurrentCompanyUserIsConfirmedLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCurrentCompanyUserIsConfirmedDocument, options);
}
var GetGupyIntegrationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject74());
/**
 * __useGetGupyIntegrationQuery__
 *
 * To run a query within a React component, call `useGetGupyIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGupyIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGupyIntegrationQuery({
 *   variables: {
 *   },
 * });
 */ function useGetGupyIntegrationQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetGupyIntegrationDocument, options);
}
function useGetGupyIntegrationLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetGupyIntegrationDocument, options);
}
var GetTechnologiesSuggestionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject75());
/**
 * __useGetTechnologiesSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetTechnologiesSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnologiesSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechnologiesSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */ function useGetTechnologiesSuggestionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetTechnologiesSuggestionsDocument, options);
}
function useGetTechnologiesSuggestionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetTechnologiesSuggestionsDocument, options);
}
var GetTechnologyByIdsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject76());
/**
 * __useGetTechnologyByIdsQuery__
 *
 * To run a query within a React component, call `useGetTechnologyByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnologyByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechnologyByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */ function useGetTechnologyByIdsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetTechnologyByIdsDocument, options);
}
function useGetTechnologyByIdsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetTechnologyByIdsDocument, options);
}
var CountHubPositionsByCompanyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject77());
/**
 * __useCountHubPositionsByCompanyQuery__
 *
 * To run a query within a React component, call `useCountHubPositionsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountHubPositionsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountHubPositionsByCompanyQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */ function useCountHubPositionsByCompanyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(CountHubPositionsByCompanyDocument, options);
}
function useCountHubPositionsByCompanyLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(CountHubPositionsByCompanyDocument, options);
}
var GetHubPositionsByCompanyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject78());
/**
 * __useGetHubPositionsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetHubPositionsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubPositionsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubPositionsByCompanyQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */ function useGetHubPositionsByCompanyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetHubPositionsByCompanyDocument, options);
}
function useGetHubPositionsByCompanyLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(GetHubPositionsByCompanyDocument, options);
}
var ListIndustriesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject79());
/**
 * __useListIndustriesQuery__
 *
 * To run a query within a React component, call `useListIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIndustriesQuery({
 *   variables: {
 *   },
 * });
 */ function useListIndustriesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ListIndustriesDocument, options);
}
function useListIndustriesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListIndustriesDocument, options);
}
var ListNumberOfDevelopersOptionsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject80());
/**
 * __useListNumberOfDevelopersOptionsQuery__
 *
 * To run a query within a React component, call `useListNumberOfDevelopersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNumberOfDevelopersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNumberOfDevelopersOptionsQuery({
 *   variables: {
 *   },
 * });
 */ function useListNumberOfDevelopersOptionsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ListNumberOfDevelopersOptionsDocument, options);
}
function useListNumberOfDevelopersOptionsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListNumberOfDevelopersOptionsDocument, options);
}
var MetabaseEmbedDashboardUrlDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject81());
/**
 * __useMetabaseEmbedDashboardUrlQuery__
 *
 * To run a query within a React component, call `useMetabaseEmbedDashboardUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetabaseEmbedDashboardUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetabaseEmbedDashboardUrlQuery({
 *   variables: {
 *      dashboard: // value for 'dashboard'
 *      role: // value for 'role'
 *   },
 * });
 */ function useMetabaseEmbedDashboardUrlQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(MetabaseEmbedDashboardUrlDocument, options);
}
function useMetabaseEmbedDashboardUrlLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(MetabaseEmbedDashboardUrlDocument, options);
}
var SearchCandidatesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject82());
/**
 * __useSearchCandidatesQuery__
 *
 * To run a query within a React component, call `useSearchCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCandidatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchId: // value for 'searchId'
 *      onlyTotals: // value for 'onlyTotals'
 *   },
 * });
 */ function useSearchCandidatesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(SearchCandidatesDocument, options);
}
function useSearchCandidatesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(SearchCandidatesDocument, options);
}
var SearchCandidatesTotalsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject83());
/**
 * __useSearchCandidatesTotalsQuery__
 *
 * To run a query within a React component, call `useSearchCandidatesTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCandidatesTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCandidatesTotalsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      searchId: // value for 'searchId'
 *      onlyTotals: // value for 'onlyTotals'
 *   },
 * });
 */ function useSearchCandidatesTotalsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(SearchCandidatesTotalsDocument, options);
}
function useSearchCandidatesTotalsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(SearchCandidatesTotalsDocument, options);
}
var SearchLanguagesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject84());
/**
 * __useSearchLanguagesQuery__
 *
 * To run a query within a React component, call `useSearchLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLanguagesQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */ function useSearchLanguagesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(SearchLanguagesDocument, options);
}
function useSearchLanguagesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(SearchLanguagesDocument, options);
}
var ValidateCompanyRegistrationDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject85());
/**
 * __useValidateCompanyRegistrationQuery__
 *
 * To run a query within a React component, call `useValidateCompanyRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCompanyRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCompanyRegistrationQuery({
 *   variables: {
 *      companyDomain: // value for 'companyDomain'
 *      companyName: // value for 'companyName'
 *   },
 * });
 */ function useValidateCompanyRegistrationQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ValidateCompanyRegistrationDocument, options);
}
function useValidateCompanyRegistrationLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ValidateCompanyRegistrationDocument, options);
}
var FindActiveJobsByCompanyUserWhoIsResponsibleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject86());
/**
 * __useFindActiveJobsByCompanyUserWhoIsResponsibleQuery__
 *
 * To run a query within a React component, call `useFindActiveJobsByCompanyUserWhoIsResponsibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindActiveJobsByCompanyUserWhoIsResponsibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindActiveJobsByCompanyUserWhoIsResponsibleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useFindActiveJobsByCompanyUserWhoIsResponsibleQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(FindActiveJobsByCompanyUserWhoIsResponsibleDocument, options);
}
function useFindActiveJobsByCompanyUserWhoIsResponsibleLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindActiveJobsByCompanyUserWhoIsResponsibleDocument, options);
}
var FindPendingBidsByCompanyUserWhoIsResponsibleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject87());
/**
 * __useFindPendingBidsByCompanyUserWhoIsResponsibleQuery__
 *
 * To run a query within a React component, call `useFindPendingBidsByCompanyUserWhoIsResponsibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPendingBidsByCompanyUserWhoIsResponsibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPendingBidsByCompanyUserWhoIsResponsibleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useFindPendingBidsByCompanyUserWhoIsResponsibleQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(FindPendingBidsByCompanyUserWhoIsResponsibleDocument, options);
}
function useFindPendingBidsByCompanyUserWhoIsResponsibleLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindPendingBidsByCompanyUserWhoIsResponsibleDocument, options);
}
var FindScheduledInterviewsByCompanyUserWhoIsResponsibleDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject88());
/**
 * __useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery__
 *
 * To run a query within a React component, call `useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useFindScheduledInterviewsByCompanyUserWhoIsResponsibleQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(FindScheduledInterviewsByCompanyUserWhoIsResponsibleDocument, options);
}
function useFindScheduledInterviewsByCompanyUserWhoIsResponsibleLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindScheduledInterviewsByCompanyUserWhoIsResponsibleDocument, options);
}
var GetAllCompanyUsersFromCurrentCompanyDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject89());
/**
 * __useGetAllCompanyUsersFromCurrentCompanyQuery__
 *
 * To run a query within a React component, call `useGetAllCompanyUsersFromCurrentCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompanyUsersFromCurrentCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompanyUsersFromCurrentCompanyQuery({
 *   variables: {
 *   },
 * });
 */ function useGetAllCompanyUsersFromCurrentCompanyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetAllCompanyUsersFromCurrentCompanyDocument, options);
}
function useGetAllCompanyUsersFromCurrentCompanyLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetAllCompanyUsersFromCurrentCompanyDocument, options);
}
var GetCompanyUserByIdDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject90());
/**
 * __useGetCompanyUserByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */ function useGetCompanyUserByIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetCompanyUserByIdDocument, options);
}
function useGetCompanyUserByIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetCompanyUserByIdDocument, options);
}
var GetFeatureFlagDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject91());
/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */ function useGetFeatureFlagQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(GetFeatureFlagDocument, options);
}
function useGetFeatureFlagLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetFeatureFlagDocument, options);
}
var FindActiveAndApprovedJobsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject92());
/**
 * __useFindActiveAndApprovedJobsQuery__
 *
 * To run a query within a React component, call `useFindActiveAndApprovedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindActiveAndApprovedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindActiveAndApprovedJobsQuery({
 *   variables: {
 *   },
 * });
 */ function useFindActiveAndApprovedJobsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FindActiveAndApprovedJobsDocument, options);
}
function useFindActiveAndApprovedJobsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindActiveAndApprovedJobsDocument, options);
}
var FindFirstJobBySlugDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject93());
/**
 * __useFindFirstJobBySlugQuery__
 *
 * To run a query within a React component, call `useFindFirstJobBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstJobBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstJobBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */ function useFindFirstJobBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FindFirstJobBySlugDocument, options);
}
function useFindFirstJobBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindFirstJobBySlugDocument, options);
}
var FindLatestApprovedJobsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject94());
/**
 * __useFindLatestApprovedJobsQuery__
 *
 * To run a query within a React component, call `useFindLatestApprovedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLatestApprovedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLatestApprovedJobsQuery({
 *   variables: {
 *      quantity: // value for 'quantity'
 *   },
 * });
 */ function useFindLatestApprovedJobsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FindLatestApprovedJobsDocument, options);
}
function useFindLatestApprovedJobsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindLatestApprovedJobsDocument, options);
}
var FindMaxMinJobsSalaryDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject95());
/**
 * __useFindMaxMinJobsSalaryQuery__
 *
 * To run a query within a React component, call `useFindMaxMinJobsSalaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMaxMinJobsSalaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMaxMinJobsSalaryQuery({
 *   variables: {
 *   },
 * });
 */ function useFindMaxMinJobsSalaryQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(FindMaxMinJobsSalaryDocument, options);
}
function useFindMaxMinJobsSalaryLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindMaxMinJobsSalaryDocument, options);
}
var FindShowcaseJobsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject96());
/**
 * __useFindShowcaseJobsQuery__
 *
 * To run a query within a React component, call `useFindShowcaseJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindShowcaseJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShowcaseJobsQuery({
 *   variables: {
 *      showcaseParams: // value for 'showcaseParams'
 *   },
 * });
 */ function useFindShowcaseJobsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FindShowcaseJobsDocument, options);
}
function useFindShowcaseJobsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(FindShowcaseJobsDocument, options);
}
var FindSimilarJobsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject97());
/**
 * __useFindSimilarJobsQuery__
 *
 * To run a query within a React component, call `useFindSimilarJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSimilarJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSimilarJobsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */ function useFindSimilarJobsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(FindSimilarJobsDocument, options);
}
function useFindSimilarJobsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(FindSimilarJobsDocument, options);
}
var GetScreeningByJobIdDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject98());
/**
 * __useGetScreeningByJobIdQuery__
 *
 * To run a query within a React component, call `useGetScreeningByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreeningByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreeningByJobIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      publishedOnly: // value for 'publishedOnly'
 *   },
 * });
 */ function useGetScreeningByJobIdQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(GetScreeningByJobIdDocument, options);
}
function useGetScreeningByJobIdLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(GetScreeningByJobIdDocument, options);
}
var ListCountriesAndCitiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject99());
/**
 * __useListCountriesAndCitiesQuery__
 *
 * To run a query within a React component, call `useListCountriesAndCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCountriesAndCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCountriesAndCitiesQuery({
 *   variables: {
 *      textSearch: // value for 'textSearch'
 *      limit: // value for 'limit'
 *   },
 * });
 */ function useListCountriesAndCitiesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ListCountriesAndCitiesDocument, options);
}
function useListCountriesAndCitiesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListCountriesAndCitiesDocument, options);
}
var ListSubscriptionPlansDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject100());
/**
 * __useListSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useListSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */ function useListSubscriptionPlansQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useQuery(ListSubscriptionPlansDocument, options);
}
function useListSubscriptionPlansLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ListSubscriptionPlansDocument, options);
}
var SearchCitiesDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject101());
/**
 * __useSearchCitiesQuery__
 *
 * To run a query within a React component, call `useSearchCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCitiesQuery({
 *   variables: {
 *      textSearch: // value for 'textSearch'
 *   },
 * });
 */ function useSearchCitiesQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(SearchCitiesDocument, options);
}
function useSearchCitiesLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(SearchCitiesDocument, options);
}
var SearchCompanyAliasDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject102());
/**
 * __useSearchCompanyAliasQuery__
 *
 * To run a query within a React component, call `useSearchCompanyAliasQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyAliasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyAliasQuery({
 *   variables: {
 *      textSearch: // value for 'textSearch'
 *   },
 * });
 */ function useSearchCompanyAliasQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(SearchCompanyAliasDocument, options);
}
function useSearchCompanyAliasLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(SearchCompanyAliasDocument, options);
}
var SearchTechsDocument = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject103());
/**
 * __useSearchTechsQuery__
 *
 * To run a query within a React component, call `useSearchTechsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTechsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTechsQuery({
 *   variables: {
 *      textSearch: // value for 'textSearch'
 *      subTypes: // value for 'subTypes'
 *   },
 * });
 */ function useSearchTechsQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(SearchTechsDocument, options);
}
function useSearchTechsLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .useLazyQuery */ .t(SearchTechsDocument, options);
}


/***/ })

}]);